<template>
  <div class="tab-order-info">
    <el-form
      :disabled="!isEditing"
      class="section"
      style="flex-direction: row;"
    >
      <span style="display: flex;align-items: center;width: 64px">
        {{ $t('FbaJob.ValueAddedServices') }}
      </span>
      <el-checkbox-group v-model="selectedLocalAddedService" @change="addedServiceChangeHandler">
        <el-checkbox
          v-for="item in localAddedService"
          :key="item.code"
          :label="item.code"
          style="margin-left: 8px;margin-right: 8px"
          @change="val => singleAddedServiceChangeHandler(val, item)"
        >
          {{ item.chineseName }}
        </el-checkbox>
      </el-checkbox-group>
      <el-checkbox v-model="form.destinationPortService" style="margin-left: 8px;margin-right: 8px" no="destinationPortService">{{ $t('SeaExport.PortOfDestinationServices') }}</el-checkbox>
    </el-form>
    <div class="section" style="width:80%; min-width:1000px">
      <span class="title">{{ $t('SeaExport.BasicInfo') }}</span>
      <div class="form-row" style="display:flex;flex-direction:row;">
        <el-form label-width="80px" label-position="right" style="margin-right:10px" :disabled="!isEditing">
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('FbaJob.BookingNo') " class="el-form-item-w240">
                <el-input v-model="form.bookingNo" :disabled="true" />
              </el-form-item>
              <el-form-item class="el-form-item-w240">
                <span slot="label" class="blue">{{ $t('SeaExport.ConsignationCompany') }}</span>
                <cargo-company-select
                  no="customerId"
                  class="shipper-selector"
                  popper-class="shipper-selector-popper"
                  :method-params="{customer:true, active:true, fba:true}"
                  :check-credit="true"
                  :job="form"
                  :default-value="form.customerId||''"
                  :static-options="customerCmpList"
                  :disabled="!customerEnabled"
                  style="flex: 1;"
                  :data-filter-function="customerIdFilter"
                  @change="p=>{customerIdChangeHandler(p)}"
                />
              </el-form-item>
              <el-form-item class="el-form-item-w240">
                <span slot="label" class="blue">{{ $t('SeaExport.Sales') }}</span>
                <cargo-user-select
                  ref="sales"
                  no="sales"
                  :method-params="{officeId:salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
                  :default-value="form.sales||''"
                  :static-options="salesList"
                  :merge-load="true"
                  @change="p=>{salesChangeHandler(p);}"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.Operation')" class="el-form-item-w240">
                <cargo-user-select
                  ref="op"
                  no="op"
                  :method-params="{officeId:form.opOffice,category:'role',shape:'op'}"
                  :default-value="form.op||''"
                  :merge-load="true"
                  @change="p=>{form.op=p.value;opChangeHandler(p)}"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('SeaExport.quotationNum')" class="el-form-item-w240">
                <el-input v-model="form.quotationNo" />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.ContactPerson')" class="el-form-item-w240">
                <el-input v-model="form.customerContact" />
              </el-form-item>
              <el-form-item class="el-form-item-w240">
                <span slot="label" class="blue">{{ $t('SeaExport.SalesDepartment') }}</span>
                <cargo-department-new-select
                  no="salesDepartment"
                  :disabled="!form.sales"
                  :sales-id="Number(form.sales)"
                  :office-id="form.salesOffice"
                  :enables="true"
                  :department-id="Number(form.salesDepartment)"
                  @change="p=>{form.salesDepartment=p.value;}"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.OperationDepartment')" class="el-form-item-w240">
                <cargo-department-select
                  no="opDepartment"
                  :office-id="Number(form.opOffice)"
                  :enables="true"
                  :department-id="Number(form.opDepartment)"
                  @change="p=>{form.opDepartment=p.value}"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('SeaExport.WarehouseNo')" class="el-form-item-w240">
                <el-input v-model="form.warehouseNo" />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.Tel')" class="el-form-item-w240">
                <el-input v-model="form.contactTelephone" />
              </el-form-item>
              <el-form-item class="el-form-item-w240">
                <span slot="label" class="blue">{{ $t('SeaExport.SalesCompany') }}</span>
                <cargo-office-select
                  no="salesOffice"
                  :office-id="Number(form.salesOffice)"
                  @change="p=>{form.salesOffice=p.value;}"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.OperationCompany')" class="el-form-item-w240">
                <cargo-office-select
                  no="opOffice"
                  :disabled="opOfficeDisabled"
                  :office-id="Number(form.opOffice)"
                  :is-regional-commission="isRegionalCommission"
                  @change="p=>{form.opOffice=p.value;form.opDepartment=0}"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item v-if="!isZY" style="height: 28px" class="el-form-item-w240" />
              <template v-if="isZY">
                <el-form-item>
                  <span slot="label" class="blue">{{ $t('SeaExport.AllowSaleProduct') }}</span>
                  <cargo-advance-select
                    :select-type="selectTypeNames.basic_data_AllowSaleProduct"
                    filterable
                    no="allowSaleProduct"
                    clearable
                    :data-filter-function="p => p.statusEnabled && (p.fbaSea || p.fbaAir || p.fbaRailway)"
                    :default-value="form.saleProductCode || ''"
                    @parentCallBack="p => {form.saleProductCode = p.value}"
                  />
                </el-form-item>
                <el-form-item>
                  <span slot="label" class="blue">{{ $t('SeaExport.FullOrInside') }}</span>
                  <cargo-advance-select
                    :select-type="selectTypeNames.local_cache_FullOrInside$FULL_OR_INSIDE"
                    no="fullOrInside"
                    clearable
                    :default-value="form.fullOrInside || ''"
                    @parentCallBack="p => {form.fullOrInside = p.value}"
                  />
                </el-form-item>
              </template>
              <el-form-item :label="$t('SeaExport.Fax')" class="el-form-item-w240">
                <el-input v-model="form.contactFax" />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.CustomerService')" class="el-form-item-w240">
                <cargo-user-select
                  ref="csr"
                  no="csr"
                  :method-params="{officeId:form.salesOffice===1?form.opOffice:form.salesOffice,category:'role',shape:'csr'}"
                  :default-value="form.csr||''"
                  :merge-load="true"
                  @change="p=>{csrChangeHandler(p);}"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.Documents')" class="el-form-item-w240">
                <cargo-user-select
                  ref="dc"
                  no="dc"
                  :method-params="{officeId:form.opOffice,category:'role',shape:'doc'}"
                  :default-value="form.dc||''"
                  :merge-load="true"
                  @change="p=>{dcChangeHandler(p)}"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="section" style="width:80%; min-width:1000px">
      <span class="title">{{ $t('CargoMsg.Cargo_ShippingInformation') }}</span>
      <div class="form-row" style="display:flex;flex-direction:row;">
        <el-form label-width="110px" label-position="right" style="margin-right:10px" :disabled="!isEditing">
          <el-row>
            <el-col style="width: 300px;">
              <el-form-item v-if="form.shippingType === 'SE' || form.shippingType === 'RE'" label-width="130px" class="el-form-item-w300">
                <span slot="label" class="blue">{{ $t('SeaExport.FLCLType') }}</span>
                <cargo-advance-select
                  no="containerLoadType"
                  :select-type="selectTypeNames.local_cache_FbaJobConstants$CONTAINER_LOAD_TYPES"
                  filterable
                  :clearable="false"
                  :default-value="form.containerLoadType"
                  @parentCallBack="p=>{form.containerLoadType=p.value}"
                />
              </el-form-item>
              <el-form-item v-if="form.shippingType === 'AE'" label-width="130px" class="el-form-item-w300">
                <span slot="label" class="blue">{{ $t('SeaExport.OperateType') }}</span>
                <cargo-advance-select
                  no="operateType"
                  :clearable="false"
                  filterable
                  :select-type="selectTypeNames.local_cache_AirExportConstants$BUSINESS_MODELS"
                  :default-value="form.operateType"
                  @parentCallBack="p=>{form.operateType=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_EstimatedAmazonArrivalTime')" label-width="130px" class="el-form-item-w300">
                <el-date-picker
                  v-model="form.preAmazonWhTime"
                  no="preAmazonWhTime"
                  type="date"
                  style="width:100%;"
                  clearable
                  value-format="yyyy-MM-dd"
                />
              </el-form-item>
              <el-form-item label-width="130px" class="el-form-item-w300">
                <span slot="label" class="blue">{{ $t('SeaExport.transportation') }}</span>
                <el-select v-model="form.shippingType" filterable @change="changeShippingType">
                  <el-option
                    v-for="(item,index) in FbaJobConstants.SHIPPING_TYPES"
                    :key="index"
                    :label="$store.getters.language === 'zh' ? item.chineseName : item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('SeaExport.POoriginalNumber')" label-width="130px" class="el-form-item-w300">
                <el-input v-model="form.poNumber" />
              </el-form-item>
              <el-form-item label-width="130px" class="el-form-item-w300">
                <span slot="label" class="blue">{{ $t('FbaJob.ChargingMethod') }}</span>
                <el-radio-group v-model="form.chargingMethod" @change="chargingMethodChange">
                  <el-radio :label="'0'">{{ 'KG' }}</el-radio>
                  <el-radio :label="'1'">{{ 'CBM' }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item :label="$t('SeaExport.PackageType')" label-width="130px" class="el-form-item-w300">
                <cargo-packing-select
                  no="packing"
                  :default-value="form.packing"
                  @change="p=>{form.packing=p.value;}"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.VATTaxNumber')" label-width="130px" class="el-form-item-w300">
                <el-input v-model="form.vatNo" @change="p=>{form.address.shipperVatNo = form.vatNo; form.address.shipperVatNoType = 'VAT';}" />
              </el-form-item>
              <el-form-item label-width="130px" class="el-form-item-w300">
                <span slot="label" class="blue">{{ $t('FbaJob.PickupService') }}</span>
                <el-radio-group v-model="form.pickupService">
                  <el-radio :label="true">{{ $t('SeaExport.yes') }}</el-radio>
                  <el-radio :label="false">{{ $t('SeaExport.no') }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-if="form.pickupService" :label="$t('SeaExport.ContactPerson')" label-width="130px" class="el-form-item-w300">
                <el-input v-model="form.doorMan" />
              </el-form-item>
              <el-form-item v-if="form.pickupService" :label="$t('SeaExport.CustomJobType')" label-width="130px" class="el-form-item-w300">
                <cargo-advance-select
                  no="customJobType2"
                  filterable
                  :select-type="selectTypeNames.basic_data_CutomJobType"
                  :method-params="{type:form.lob, fba: true, active: true}"
                  callback-method-type="value"
                  :default-value="form.customJobType"
                  :callback-params="{key:'customJobType'}"
                  placeholder=" "
                  @parentCallBack="p=>{form.customJobType=p.value}"
                />
              </el-form-item>
            </el-col>
            <el-col style="width: 280px;">
              <el-form-item v-if="!isEditing" :label="$t('SeaExport.ServiceChannel')" class="el-form-item-w280">
                <cargo-advance-select
                  no="serviceChannel"
                  disabled
                  :select-type="selectTypeNames.basic_data_FbaChannel"
                  filterable
                  :method-params="{active: true}"
                  :clearable="true"
                  :default-value="form.serviceChannel"
                  @parentCallBack="p=>{form.serviceChannel=p.value;}"
                />
              </el-form-item>
              <el-form-item v-if="isEditing" :label="$t('SeaExport.ServiceChannel')" class="el-form-item-w280">
                <el-select v-model="form.serviceChannel" filterable clearable @change="changeServiceChannel">
                  <el-option
                    v-for="(item,index) in channel4JobSelect"
                    :key="index"
                    :label="item.channelName"
                    :value="item.channelName"
                  />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('SeaExport.PortOfLoadingAI')" class="el-form-item-w280">
                <cargo-advance-select
                  ref="loadingPortCode"
                  no="loadingPortCode"
                  :select-type="loadingPortType"
                  filterable
                  :default-value="form.loadingPortCode"
                  @parentCallBack="p=>{form.loadingPortCode=p.value}"
                />&nbsp;
              </el-form-item>
              <el-form-item :label="$t('SeaExport.DestinationDeliveryMethod')" class="el-form-item-w280">
                <el-select v-model="form.destinationDistribution" filterable @change="destinationDistributionChange">
                  <el-option
                    v-for="(item,index) in FbaJobConstants.ORDER_DESTINATION_DISTRIBUTION_TYPES"
                    :key="index"
                    :label="$store.getters.language === 'zh' ? item.chineseName : item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <el-form-item v-if="form.destinationDistribution && Number(form.destinationDistribution) === 1" :label="$t('SeaExport.CourierCompany')" class="el-form-item-w280">
                <el-select v-model="form.expressCompany" no="expressCompany" placeholder="" clearable>
                  <el-option
                    v-for="item in FbaJobConstants.EXPRESS_COMPANYS"
                    :key="item.code"
                    :label="item.chineseName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="Shipment Id" class="el-form-item-w280">
                <el-input v-model="form.shipmentId" />
              </el-form-item>
              <el-form-item :label="$t('FbaJob.BubbleCountingRatio')" label-width="60px" style="margin-bottom: 2px !important;">
                <el-input v-model="form.bubbleCountingRatio" style="width: 60px;" @change="bubbleCountingChange" />
                <span style="margin-left: 5px; margin-right: 10px;">{{ $t('FbaJob.BubbleSplittingRatio') }}</span>
                <el-input v-model="form.bubbleSplittingRatio" style="width: 60px;" @change="bubbleSplittingRatioChange" />
                <!--                <el-input-number v-model="form.bubbleSplittingRatio" style="width: 75px;" controls-position="right" :max="100" :min="0" :precision="0" @change="bubbleSplittingRatioChange" />-->
                <span style="margin-left: 1px;">%</span>
              </el-form-item>
              <el-form-item class="el-form-item-w280">
                <span slot="label" class="blue">{{ $t('SeaExport.CargoType') }}</span>
                <el-select v-model="form.cargoType" filterable>
                  <el-option
                    v-for="(item,index) in cargoType4JobSelect"
                    :key="index"
                    :label="item.chineseName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('SeaExport.VATRegistrationCountry')" class="el-form-item-w280">
                <cargo-advance-select
                  no="taxRegisterCountry"
                  :select-type="selectTypeNames.basic_data_Country"
                  filterable
                  :callback-params="{key:'taxRegisterCountry'}"
                  callback-method-type="value"
                  :default-value="form.taxRegisterCountry"
                  @parentCallBack="p=>{form.taxRegisterCountry = p.value}"
                />
              </el-form-item>
              <el-form-item v-if="!form.pickupService" :label="$t('SeaExport.CustomJobType')" class="el-form-item-w280">
                <cargo-advance-select
                  no="customJobType1"
                  filterable
                  :select-type="selectTypeNames.basic_data_CutomJobType"
                  :method-params="{type:form.lob, fba: true, active: true}"
                  callback-method-type="value"
                  :default-value="form.customJobType"
                  :callback-params="{key:'customJobType'}"
                  placeholder=" "
                  @parentCallBack="p=>{form.customJobType=p.value}"
                />
              </el-form-item>
              <el-form-item v-if="form.pickupService" :label="$t('FbaJob.PickupTime')" class="el-form-item-w280">
                <el-date-picker
                  v-model="form.pickupTime"
                  no="pickupTime"
                  type="datetime"
                  style="width:100%;"
                  clearable
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                />
              </el-form-item>
              <el-form-item v-if="form.pickupService" :label="$t('FbaJob.DoorManTel')" class="el-form-item-w280">
                <el-input v-model="form.doorManTel" />
              </el-form-item>
            </el-col>
            <el-col style="width: 280px;">
              <el-form-item :label="$t('FbaJob.DomesticWarehouse')" class="el-form-item-w290">
                <cargo-company-select
                  :method-params="{warehouse:true,active:true}"
                  :default-value="Number(form.domesticWarehouse)||''"
                  @change="p=>{form.domesticWarehouse=p.value}"
                />
              </el-form-item>
              <el-form-item class="el-form-item-w290">
                <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_Destination') }}</span>
                <div style="display: flex; justify-content: space-between">
                  <el-tooltip :content="form.warehouseCode" placement="bottom-end">
                    <el-cascader
                      v-model="form.warehouseCode"
                      :options="destinations"
                      filterable
                      :clearable="true"
                      @focus="JobUtils.focusWarehouseCode(form)"
                      @blur="JobUtils.blurWarehouseCode(form)"
                      @change="p=>{JobUtils.warehouseCodeHandler(form, p);syncConsigneeInfo();changeWarehouseCode()}"
                    />
                  </el-tooltip>
                  <el-checkbox v-model="form.remoteWarehouse" style="margin-left: 2px;">{{ $t('SeaExport.RemoteWarehouse') }}</el-checkbox>
                </div>
              </el-form-item>
              <el-form-item :label="$t('SeaExport.TradeTerms2')" class="el-form-item-w290">
                <cargo-advance-select
                  no="incoTerm"
                  :select-type="selectTypeNames.basic_data_IncoTerm"
                  filterable
                  :clearable="false"
                  :default-value="form.incoTerm"
                  @parentCallBack="p=>{form.incoTerm=p.value}"
                />
              </el-form-item>
              <el-form-item label="Reference Id" class="el-form-item-w290">
                <el-input v-model="form.referenceId" />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.CustomsDeclarationWay')" class="el-form-item-w290">
                <cargo-advance-select
                  no="customsMethodPol"
                  :select-type="selectTypeNames.basic_data_CustomsMode"
                  :method-params="{serviceType:0}"
                  filterable
                  :clearable="false"
                  :default-value="form.customsMethodPol"
                  @parentCallBack="p=>{form.customsMethodPol=p.value}"
                />
              </el-form-item>
              <el-form-item label-width="0" style="margin-bottom: 2px !important;">
                <el-checkbox v-model="form.electric" style="margin-right: 10px;margin-left: 20px;">{{
                  $t('FbaJob.ElectricCol')
                }}
                </el-checkbox>
                <el-checkbox v-model="form.magnetic" style="margin-right: 10px;">{{ $t('FbaJob.MagneticCol') }}</el-checkbox>
                <el-checkbox v-model="form.powdery" style="margin-right: 10px;">{{ $t('FbaJob.PowderyCol') }}</el-checkbox>
                <el-checkbox v-model="form.liquid" style="margin-right: 10px;">{{ $t('FbaJob.LiquidCol') }}</el-checkbox>
              </el-form-item>
              <el-form-item :label="$t('FbaJob.TaxRegisterAddress')" class="el-form-item-w290">
                <el-input v-model="form.taxRegisterAddress" />
              </el-form-item>
              <el-form-item v-if="form.pickupService" :label="$t('FbaJob.PickupDoor')" class="el-form-item-w290">
                <cargo-repeat-value-select
                  v-model="form.pickupDoor"
                  filterable
                  :allow-create="true"
                  clearable
                  :options="doorList"
                  label-field="name"
                  value-field="name"
                  unique-field="uuid"
                  :match-of-repeat-value="matchOfRepeatDoor"
                  @change="doorsChangeHandler"
                />
              </el-form-item>
              <el-form-item v-if="form.pickupService" :label="$t('FbaJob.DoorAddress')" class="el-form-item-w290">
                <el-input v-model="form.doorAddress" />
              </el-form-item>
            </el-col>
            <el-col style="width: 290px;">
              <el-form-item label-width="120px" class="el-form-item-w290">
                <span slot="label" class="blue">{{ $t('SeaExport.EstimatedWarehouseEntrygoodArrivalTime') }}</span>
                <el-date-picker
                  v-model="form.preWarehousingTime"
                  no="preWarehousingTime"
                  type="datetime"
                  style="width:100%;"
                  clearable
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                />
              </el-form-item>
              <!--              <el-form-item>
                <span slot="label" class="blue">{{ '预计入库/货好时间' }}</span>
                <el-date-picker
                  v-model="form.preWarehousingTime"
                  no="preWarehousingTime"
                  type="datetime"
                  style="width:100%;"
                  clearable
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                />
              </el-form-item>-->
              <el-form-item label-width="55px" style="margin-bottom: 2px !important;">
                <span slot="label" class="blue">{{ $t('Warehouse.DestinationCountry') }}</span>
                <el-input v-model="form.country" :disabled="true" style="width: 80px;" />
                <span style="margin-left: 11px; margin-right: 10px;" class="blue">{{ $t('SeaExport.ZIP') }}</span>
                <el-input v-model="form.zipCode" :disabled="true" style="width: 100px;" />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.ClientsRequirement')" label-width="120px" class="el-form-item-w290">
                <el-tooltip ref="customerRequireTip" :content="form.customerRequire" placement="right" :open-delay="300" trigger="hover">
                  <el-input v-model="form.customerRequire" class="custom-textarea" type="textarea" :row="3" @mouseenter="updateTooltip('customerRequireTip')" />
                </el-tooltip>
              </el-form-item>
              <el-form-item :label="$t('SeaExport.CustomsClearanceMethod')" label-width="120px" class="el-form-item-w290">
                <cargo-advance-select
                  no="customsMethodPod"
                  :select-type="selectTypeNames.basic_data_CustomsMode"
                  :method-params="{serviceType:1}"
                  filterable
                  :clearable="false"
                  :default-value="form.customsMethodPod"
                  @parentCallBack="p=>{form.customsMethodPod=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.EORIEnterpriseNumber')" label-width="120px" class="el-form-item-w290">
                <el-input v-model="form.eoriNo" @change="p=>{form.address.shipperEoriNo = form.eoriNo}" />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.VATCompanyEnglishName')" label-width="120px" class="el-form-item-w290">
                <el-input v-model="form.taxCompany" />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.Remarks')" label-width="120px" class="el-form-item-w290">
                <el-tooltip ref="remarksTip" :content="form.remarks" placement="right" :open-delay="300" trigger="hover">
                  <el-input v-model="form.remarks" class="custom-textarea" type="textarea" :row="3" @mouseenter="updateTooltip('remarksTip')" />
                </el-tooltip>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="section" style="width:80%; min-width:1000px">
      <span class="title">{{ $t('SeaExport.ConsigneeShipperAndNotifyInfo') }}</span>
      <div class="form-row" style="display:flex;flex-direction:row;">
        <el-form label-width="90px" label-position="right" style="margin-right:10px" :disabled="!isEditing">
          <el-row>
            <el-col style="width: 370px;">
              <div style="display: flex;">
                <el-tag size="medium" class="tag-w">{{ $t('baseInfo.mailingAddress.shipper') }}</el-tag>
              </div>
              <div class="el-form-item-wrapper">
                <div class="expanded-div">
                  <el-form-item class="el-form-item-w380">
                    <div style="display: flex;  float: right;">
                      <el-button no="shipperIdBtn" type="primary" @click="fbaCodeSearchBtn">{{
                        $t('CargoMsg.Cargo_SelectCommonShipper')
                      }}
                      </el-button>
                      <el-button no="shipperIdSaveBtn" type="primary" @click="saveBillAddressDialog('shipper')">
                        {{ $t('CargoMsg.Cargo_SaveAsCommonShipper') }}
                      </el-button>
                    </div>
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.CompanyName')" class="el-form-item-w380">
                    <el-input v-model="form.address.shipperEnterpriseName" v-uppercase no="13" />
                  </el-form-item>
                  <el-form-item :label="$t('baseInfo.mailingAddress.contactName')" class="el-form-item-w380">
                    <el-input v-model="form.address.shipperContactName" v-uppercase no="14" style="width: 110px;" />
                    <span style="margin-left: 9px; margin-right: 12px;">{{ $t('CargoMsg.Cargo_Tel') }}</span>
                    <el-input v-model="form.address.shipperContactTel" v-uppercase no="15" style="width: 125px;" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_email')" class="el-form-item-w380">
                    <el-input v-model="form.address.shipperContactEmail" v-uppercase no="16" style="width: 110px;" />
                    <span style="margin-left: 9px; margin-right: 12px;">{{ $t('CargoMsg.Cargo_Fax') }}</span>
                    <el-input v-model="form.address.shipperFax" v-uppercase no="17" style="width: 125px;" />
                  </el-form-item>
                  <div class="el-form-item-wrapper" style="display: flex;">
                    <el-form-item :label="$t('SeaExport.ZIP')" class="el-form-item-w200">
                      <el-input v-model="form.address.shipperZipCode" v-uppercase no="18" style="width: 110px;" />
                    </el-form-item>
                    <el-form-item label-width="45px" :label="$t('CargoMsg.Cargo_Country')" class="el-form-item-w170">
                      <cargo-advance-select
                        no="38"
                        :select-type="selectTypeNames.basic_data_Country"
                        filterable
                        :callback-params="{key:'shipperCountryCode'}"
                        callback-method-type="value"
                        :default-value="form.address.shipperCountryCode"
                        @parentCallBack="selectCargoItem"
                      />
                    </el-form-item>
                  </div>
                  <el-form-item :label="$t('baseInfo.mailingAddress.province')" class="el-form-item-w380">
                    <!--                      <cargo-advance-select
                      :select-type="selectTypeNames.basic_data_AdministrativeDivision"
                      filterable
                      :callback-params="{key:'shipperProvinceCode'}"
                      callback-method-type="value"
                      :static-options="provinceList"
                      :default-value="form.address.shipperProvinceCode"
                      @parentCallBack="selectCargoItem"
                    />-->
                    <el-input v-model="form.address.shipperProvinceCode" v-uppercase no="20" />
                  </el-form-item>
                  <el-form-item :label="$t('route.city')" class="el-form-item-w380">
                    <!--                      <cargo-advance-select
                      :select-type="selectTypeNames.basic_data_AdministrativeDivision"
                      filterable
                      :callback-params="{key:'shipperCityCode'}"
                      callback-method-type="value"
                      :static-options="cityList"
                      :default-value="form.address.shipperCityCode"
                      @parentCallBack="selectCargoItem"
                    />-->
                    <el-input v-model="form.address.shipperCityCode" v-uppercase no="21" />
                  </el-form-item>
                  <el-form-item :label="$t('baseInfo.mailingAddress.addr1')" class="el-form-item-w380">
                    <el-input v-model="form.address.shipperAddress1" v-uppercase no="22" />
                  </el-form-item>
                  <el-form-item :label="$t('baseInfo.mailingAddress.addr2')" class="el-form-item-w380">
                    <el-input v-model="form.address.shipperAddress2" v-uppercase no="23" />
                  </el-form-item>
                  <el-form-item :label="$t('baseInfo.mailingAddress.addr3')" class="el-form-item-w380">
                    <el-input v-model="form.address.shipperAddress3" v-uppercase no="24" />
                  </el-form-item>
                  <el-form-item :label="$t('baseInfo.mailingAddress.eoriNo')" class="el-form-item-w380">
                    <el-input v-model="form.address.shipperEoriNo" v-uppercase no="25" />
                  </el-form-item>
                  <el-form-item :label="$t('baseInfo.mailingAddress.taxNo')" class="el-form-item-w380">
                    <el-input v-model="form.address.shipperVatNo" v-uppercase style="width:210px;" />
                    <el-select v-model="form.address.shipperVatNoType" style="width:70px;padding-left: 2px;" placeholder="" no="26">
                      <el-option
                        v-for="item in SystemConstants.VAT_NO_TYPES"
                        :key="item.code"
                        :label="item.code"
                        :value="item.code"
                      />
                    </el-select>
                  </el-form-item>
                </div>
              </div>
            </el-col>
            <el-col style="width: 370px;">
              <el-tag size="medium" class="tag-w">{{ $t('baseInfo.mailingAddress.consignee') }}</el-tag>
              <div class="el-form-item-wrapper">
                <div class="expanded-div">
                  <el-form-item class="el-form-item-w380">
                    <div style="display: flex;  float: right;">
                      <el-button no="consigneeIdBtn" type="primary" style="vertical-align: top" @click="fbaCodeSearchBtn">
                        {{ $t('CargoMsg.Cargo_SelectCommonConsignee') }}
                      </el-button>
                      <el-button no="consigneeIdSaveBtn" type="primary" @click="saveBillAddressDialog('consignee')">
                        {{ $t('CargoMsg.Cargo_SaveAsCommonConsignee') }}
                      </el-button>
                    </div>
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.CompanyName')" class="el-form-item-w380">
                    <el-input v-model="form.address.consigneeEnterpriseName" v-uppercase no="32" />
                  </el-form-item>
                  <el-form-item :label="$t('baseInfo.mailingAddress.contactName')" class="el-form-item-w380">
                    <el-input v-model="form.address.consigneeContactName" v-uppercase no="14" style="width: 110px;" />
                    <span style="margin-left: 9px; margin-right: 12px;">{{ $t('CargoMsg.Cargo_Tel') }}</span>
                    <el-input v-model="form.address.consigneeContactTel" v-uppercase no="15" style="width: 125px;" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_email')" class="el-form-item-w380">
                    <el-input v-model="form.address.consigneeContactEmail" v-uppercase no="16" style="width: 110px;" />
                    <span style="margin-left: 9px; margin-right: 12px;">{{ $t('CargoMsg.Cargo_Fax') }}</span>
                    <el-input v-model="form.address.consigneeFax" v-uppercase no="17" style="width: 125px;" />
                  </el-form-item>
                  <div class="el-form-item-wrapper" style="display: flex;">
                    <el-form-item :label="$t('SeaExport.ZIP')" class="el-form-item-w200">
                      <el-input v-model="form.address.consigneeZipCode" v-uppercase no="18" style="width: 110px;" />
                    </el-form-item>
                    <el-form-item label-width="45px" :label="$t('CargoMsg.Cargo_Country')" class="el-form-item-w170">
                      <cargo-advance-select
                        no="38"
                        :select-type="selectTypeNames.basic_data_Country"
                        filterable
                        :callback-params="{key:'consigneeCountryCode'}"
                        callback-method-type="value"
                        :default-value="form.address.consigneeCountryCode"
                        @parentCallBack="selectCargoItem"
                      />
                    </el-form-item>
                  </div>

                  <el-form-item :label="$t('baseInfo.mailingAddress.province')" class="el-form-item-w380">
                    <!--                      <cargo-advance-select
                                            :select-type="selectTypeNames.basic_data_AdministrativeDivision"
                                            filterable
                                            :callback-params="{key:'consigneeProvinceCode'}"
                                            callback-method-type="value"
                                            :static-options="provinceList"
                                            :default-value="form.address.consigneeProvinceCode"
                                            @parentCallBack="selectCargoItem"
                                          />-->
                    <el-input v-model="form.address.consigneeProvinceName" v-uppercase no="39" />
                  </el-form-item>
                  <el-form-item :label="$t('route.city')" class="el-form-item-w380">
                    <!--                      <cargo-advance-select
                                            :select-type="selectTypeNames.basic_data_AdministrativeDivision"
                                            filterable
                                            :callback-params="{key:'consigneeCityCode'}"
                                            callback-method-type="value"
                                            :static-options="cityList"
                                            :default-value="form.address.consigneeCityCode"
                                            @parentCallBack="selectCargoItem"
                                          />-->
                    <el-input v-model="form.address.consigneeCityName" v-uppercase no="40" />
                  </el-form-item>
                  <el-form-item :label="$t('baseInfo.mailingAddress.addr1')" class="el-form-item-w380">
                    <el-input v-model="form.address.consigneeAddress1" v-uppercase no="41" />
                  </el-form-item>
                  <el-form-item :label="$t('baseInfo.mailingAddress.addr2')" class="el-form-item-w380">
                    <el-input v-model="form.address.consigneeAddress2" v-uppercase no="42" />
                  </el-form-item>
                  <el-form-item :label="$t('baseInfo.mailingAddress.addr3')" class="el-form-item-w380">
                    <el-input v-model="form.address.consigneeAddress3" v-uppercase no="43" />
                  </el-form-item>
                  <el-form-item :label="$t('baseInfo.mailingAddress.eoriNo')" class="el-form-item-w380">
                    <el-input v-model="form.address.consigneeEoriNo" v-uppercase no="44" />
                  </el-form-item>
                  <el-form-item :label="$t('baseInfo.mailingAddress.taxNo')" class="el-form-item-w380">
                    <el-input v-model="form.address.consigneeVatNo" v-uppercase no="45" style="width:210px;" />
                    <el-select v-model="form.address.consigneeVatNoType" style="width:70px;padding-left: 2px;" placeholder="" no="46">
                      <el-option
                        v-for="item in SystemConstants.VAT_NO_TYPES"
                        :key="item.code"
                        :label="item.code"
                        :value="item.code"
                      />
                    </el-select>
                  </el-form-item>
                </div>
              </div>
            </el-col>
            <el-col style="width: 370px;">
              <el-tag size="medium" class="tag-w">{{ $t('baseInfo.mailingAddress.notify') }}</el-tag>
              <div class="el-form-item-wrapper">
                <div class="expanded-div">
                  <el-form-item class="el-form-item-w380">
                    <div style="display: flex; float: right;">
                      <el-button no="notifyIdBtn" type="primary" style="vertical-align: top" @click="fbaCodeSearchBtn">
                        {{ $t('CargoMsg.Cargo_SelectCommonNotifier') }}
                      </el-button>
                      <el-button no="notifyIdSaveBtn" type="primary" @click="saveBillAddressDialog('notify')">
                        {{ $t('CargoMsg.Cargo_SaveAsCommonNotifier') }}
                      </el-button>
                    </div>
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.CompanyName')" class="el-form-item-w380">
                    <el-input v-model="form.address.notifyEnterpriseName" v-uppercase no="52" />
                  </el-form-item>
                  <el-form-item :label="$t('baseInfo.mailingAddress.contactName')" class="el-form-item-w380">
                    <el-input v-model="form.address.notifyContactName" v-uppercase no="14" style="width: 110px;" />
                    <span style="margin-left: 9px; margin-right: 12px;">{{ $t('CargoMsg.Cargo_Tel') }}</span>
                    <el-input v-model="form.address.notifyContactTel" v-uppercase no="15" style="width: 125px;" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_email')" class="el-form-item-w380">
                    <el-input v-model="form.address.notifyContactEmail" v-uppercase no="16" style="width: 110px;" />
                    <span style="margin-left: 9px; margin-right: 12px;">{{ $t('CargoMsg.Cargo_Fax') }}</span>
                    <el-input v-model="form.address.notifyFax" v-uppercase no="17" style="width: 125px;" />
                  </el-form-item>
                  <div class="el-form-item-wrapper" style="display: flex;">
                    <el-form-item :label="$t('SeaExport.ZIP')" class="el-form-item-w200">
                      <el-input v-model="form.address.notifyZipCode" v-uppercase no="18" style="width: 110px;" />
                    </el-form-item>
                    <el-form-item label-width="45px" :label="$t('CargoMsg.Cargo_Country')" class="el-form-item-w170">
                      <cargo-advance-select
                        no="38"
                        :select-type="selectTypeNames.basic_data_Country"
                        filterable
                        :callback-params="{key:'notifyCountryCode'}"
                        callback-method-type="value"
                        :default-value="form.address.notifyCountryCode"
                        @parentCallBack="selectCargoItem"
                      />
                    </el-form-item>
                  </div>
                  <el-form-item :label="$t('baseInfo.mailingAddress.province')" class="el-form-item-w380">
                    <!--                      <cargo-advance-select
                                            :select-type="selectTypeNames.basic_data_AdministrativeDivision"
                                            filterable
                                            :callback-params="{key:'notifyProvinceCode'}"
                                            callback-method-type="value"
                                            :static-options="provinceList"
                                            :default-value="form.address.notifyProvinceCode"
                                            @parentCallBack="selectCargoItem"
                                          />-->
                    <el-input v-model="form.address.notifyProvinceCode" v-uppercase no="59" />
                  </el-form-item>
                  <el-form-item :label="$t('route.city')" class="el-form-item-w380">
                    <!--                      <cargo-advance-select
                                            :select-type="selectTypeNames.basic_data_AdministrativeDivision"
                                            filterable
                                            :callback-params="{key:'notifyCityCode'}"
                                            callback-method-type="value"
                                            :static-options="cityList"
                                            :default-value="form.address.notifyCityCode"
                                            @parentCallBack="selectCargoItem"
                                          />-->
                    <el-input v-model="form.address.notifyCityCode" v-uppercase no="60" />
                  </el-form-item>
                  <el-form-item :label="$t('baseInfo.mailingAddress.addr1')" class="el-form-item-w380">
                    <el-input v-model="form.address.notifyAddress1" v-uppercase no="61" />
                  </el-form-item>
                  <el-form-item :label="$t('baseInfo.mailingAddress.addr2')" class="el-form-item-w380">
                    <el-input v-model="form.address.notifyAddress2" v-uppercase no="62" />
                  </el-form-item>
                  <el-form-item :label="$t('baseInfo.mailingAddress.addr3')" class="el-form-item-w380">
                    <el-input v-model="form.address.notifyAddress3" v-uppercase no="63" />
                  </el-form-item>
                  <el-form-item :label="$t('baseInfo.mailingAddress.eoriNo')" class="el-form-item-w380">
                    <el-input v-model="form.address.notifyEoriNo" v-uppercase no="64" />
                  </el-form-item>
                  <el-form-item :label="$t('baseInfo.mailingAddress.taxNo')" class="el-form-item-w380">
                    <el-input v-model="form.address.notifyVatNo" v-uppercase no="65" style="width:210px;" />
                    <el-select v-model="form.address.notifyVatNoType" no="66" style="width:70px;padding-left: 2px;" placeholder="">
                      <el-option
                        v-for="item in SystemConstants.VAT_NO_TYPES"
                        :key="item.code"
                        :label="item.code"
                        :value="item.code"
                      />
                    </el-select>
                  </el-form-item>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="section" style="width:80%; min-width:1000px">
      <span class="title">{{ $t('SeaExport.ContainerInfo2') }}</span>
      <div class="form-row grid-list" style="min-width:1000px">
        <el-form label-width="100px" label-position="left" style="margin-right:10px">
          <el-form class="spacing">
            <el-radio-group v-model="goodsViewType">
              <el-radio label="detail">{{ $t('Warehouse.Detail') }}</el-radio>
              <el-radio label="summary">{{ $t('Warehouse.Summary') }}</el-radio>
            </el-radio-group>
          </el-form>
          <el-form class="spacing">
            <el-button v-if="!goodsViewSummary" :disabled="!isEditing" type="primary" @click="addDetailHandler">
              {{ $t('Warehouse.AddCargo') }}
            </el-button>
            <el-dropdown
              no="exportOrderHandle"
              split-button
              type="primary"
              :disabled="isEditing || isChecking || isVerify"
              style="margin:0 5px"
              @click="exportOrderHandle()"
            >
              <span v-if="exportOrderCommand === this.$t('CargoMsg.Cargo_DownloadTemplate')">{{ exportOrderCommand }}</span>
              <el-upload
                v-if="[$t('SeaExport.batchImport'), $t('SeaExport.GoodsInformationImport')].includes(exportOrderCommand)"
                :action="URL.fba.batchImport"
                :headers="headers"
                :show-file-list="false"
                accept=".xls, .xlsx"
                :before-upload="beforeOrderUpload"
                :on-success="uploadOrderSuccess"
                :on-error="handleError"
                :data="{uuid:form.uuid}"
                style="display: inline-block; margin-left: 5px"
                :disabled="isEditing || isChecking"
              >
                <span style="color: white">{{
                  [$t('SeaExport.batchImport'), $t('SeaExport.GoodsInformationImport')].includes(exportOrderCommand) ? exportOrderCommand : ''
                }}</span>
              </el-upload>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="$t('SeaExport.GoodsInformationImport')">
                  <el-upload
                    ref="uploadOrder"
                    :action="URL.fba.batchImport"
                    :headers="headers"
                    :show-file-list="false"
                    accept=".xls, .xlsx"
                    :before-upload="beforeOrderUpload"
                    :on-success="uploadOrderSuccess"
                    :on-error="handleError"
                    :data="{uuid:form.uuid}"
                    style="display: inline-block"
                  >
                    <el-button slot="trigger" type="text" style="padding-left: 0px;color: #6F6F6F;text-align: left;width: 80px;">
                      {{ $t('SeaExport.GoodsInformationImport') }}
                    </el-button>
                  </el-upload>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button no="16" type="text" style="padding-left: 0px;color: #6F6F6F;text-align: left;width: 80px;" @click="downLoadDetail()">
                    {{ $t('CargoMsg.Cargo_DownLoad_Detail') }}
                  </el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button no="16" type="text" style="padding-left: 0px;color: #6F6F6F;text-align: left;width: 80px;" @click="downLoadSummary()">
                    {{ $t('CargoMsg.Cargo_DownLoad_Summary') }}
                  </el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button type="primary" :disabled="!isEditing" @click="batchAddHandler">{{ $t('Warehouse.BatchMaintenance') }}</el-button>
            <el-button type="danger" :disabled="!isEditing" @click="delAllHandler">{{ $t('SeaExport.emptyDestinationInformation') }}</el-button>
            <el-button type="danger" :disabled="!isEditing" @click="delDetailHandler">{{ $t('Warehouse.DeleteCargo') }}</el-button>
            <!--            <span style="margin-left: 10px; margin-right: 2px;">{{ '总件数（委托）' }}</span>-->
            <!--            <el-input-number v-model="form.quantityContract" :disabled="true" :controls="false" :precision="0" :min="0" :max="999999999" style="width: 100px;" />PCS-->
            <!--            <span style="margin-left: 10px; margin-right: 2px;">{{ '总重量（委托）' }}</span>-->
            <!--            <el-input-number v-model="form.weightContract" :disabled="true" :controls="false" :precision="2" :min="0" :max="999999999" style="width: 100px;" />KGS-->
            <!--            <span style="margin-left: 10px; margin-right: 2px;">{{ '总体积（委托）' }}</span>-->
            <!--            <el-input-number v-model="form.cubageContract" :disabled="true" :controls="false" :precision="3" :min="0" :max="999999999" style="width: 100px;" />CBM-->
          </el-form>
          <cargo-ag-grid
            v-if="!goodsViewSummary"
            ref="goodsDetailTable"
            config-module="93000021"
            :grid-options="detailList.goodGridOptions"
            :column-defs="dynamicGoodsColumnDefs"
            :row-data="form.goods || []"
            style="height: 200px"
            @gridReady="params=>{detailList.gridApi=params.api}"
          />
          <cargo-ag-grid
            v-if="goodsViewSummary"
            ref="goodsSummaryTable"
            config-module="93000020"
            :grid-options="detailList.goodGridOptions"
            :column-defs="dynamicGoodsColumnDefs"
            :row-data="summaryGoodsDetailList || []"
            style="height: 200px"
            @gridReady="params=>{detailList.gridApi=params.api}"
          />
          <el-form class="spacing" label-position="left">
            <span style="margin-right: 4px">{{ $t('FbaJob.QuantityContract') }}</span>
            <input
              v-model="quantityContract"
              :disabled="!isEditing"
              style="height: 28px;width: 96px;text-align: right"
              @change="changeQuantity"
            >
            <span style="margin-left: 4px">PCS</span>
            <span style="margin-left: 12px;margin-right: 4px">{{ $t('FbaJob.WeightContract') }}</span>
            <input
              v-model="weightContract"
              :disabled="!isEditing"
              style="height: 28px;width: 96px;text-align: right"
              @change="changeWeight"
            >
            <span style="margin-left: 4px">KGS</span>
            <span style="margin-left: 12px;margin-right: 4px">{{ $t('FbaJob.CubageContract') }}</span>
            <input
              v-model="cubageContract"
              :disabled="!isEditing"
              style="height: 28px;width: 96px;text-align: right"
              @change="changeCubage"
            >
            <span style="margin-left: 4px">CBM</span>
            <span style="margin-left: 12px;margin-right: 4px">{{ $t('FbaJob.VolumetricWeight') }}</span>
            <input
              v-model="volumetricWeightContract"
              :disabled="!isEditing"
              style="height: 28px;width: 96px;text-align: right"
              @change="changeVolumetricWeight"
            >
            <span style="margin-left: 4px">KGS</span>
            <span style="margin-left: 12px;margin-right: 4px">{{ $t('FbaJob.ChargedWeight') }}</span>
            <input
              v-model="chargeWeightContract"
              :disabled="!isEditing"
              style="height: 28px;width: 96px;text-align: right"
              @change="changeChargeWeight"
            >
            <span style="margin-left: 4px">KGS</span>
          </el-form>
        </el-form>
      </div>
    </div>
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog
      :visible.sync="billAddressDialog.visible"
      :job="form"
      :customer-cmp-list="customerCmpList"
      :fba="true"
      @callback="codeSearchCallback"
    />
    <!-- 货箱编号编辑弹窗 -->
    <container-no-editor
      v-if="containerNoEditor.visible"
      :boxes-number="containerNoEditor.boxesNumber"
      :visible.sync="containerNoEditor.visible"
      :shipment-id="containerNoEditor.shipmentId"
      :source="goodsViewType"
      :container-no="containerNoEditor.containerNo"
      :warehouse-in-detail-list="form.goods"
      @summarySaveCallBack="containerNoEditor.summarySaveCallBack"
      @detailSaveCallBack="containerNoEditor.detailSaveCallBack"
      @close="containerNoEditor.visible=false"
    />
    <!-- 批量维护弹窗 -->
    <batch-maintenance-dialog
      v-if="batchMaintenanceDialog.visible"
      :visible.sync="batchMaintenanceDialog.visible"
      :exist-detail-list="form.goods"
      @saveCallBack="batchMaintenanceDialog.saveCallBack"
      @close="batchMaintenanceDialog.visible=false"
    />
  </div>
</template>

<script>
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'

import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import cargoDepartmentNewSelect from '@/components/Cargo/Common/cargoDepartmentNewSelect'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import cargoRepeatValueSelect from '@/components/Cargo/Common/cargoRepeatValueSelect'

import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridColumnEditGroup from '@/components/Cargo/Common/CargoAgGridColumnEditGroup'
import billAddressDialog from './billAddressDialog'
import URL from '@/api/urlTranslator'
import { getSites } from '@/api/company'

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cache, cacheName } from '@/utils/cacheManager'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { getCacheListByKey, getObjectByCache, getSpecificBasicDataFromCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'

import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import { Company } from '@/class/model/mdm/Company'
import { getGridSelected } from '@/utils/agGrid'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import containerNoEditor from '@/views/cargo/v0/FBA/ContainerNoEditor'
import batchMaintenanceDialog from '@/views/cargo/v0/FBA/batchMaintenanceDialog'
import { TabError } from '@/utils/class/TabError'
import StrUtils from '@/utils/StrUtils'
import * as FbaJobConstants from '@/class/cargo/model/parameters/FbaJobConstants'
import { FbaJob } from '@/class/model/booking/FbaJob'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { saveBillAddress } from '@/api/Fba/fbaJob'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'
import { getFbaCustomerByRole } from '@/api/booking/job'
import { getUserInfo } from '@/utils/auth'
import CargoCascader from '@/components/Cargo/Common/cargoCascader'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { getJobAvailableChannels } from '@/api/Fba/fbaChannel'
import { FbaQuotation } from '@/class/model/price/FbaQuotation'
import { FbaQuotationUtil } from '@/class/cargo/model/utils/FbaQuotationUtil'
import { searchCustomerPrice } from '@/api/price/fbaQuotation'
import { Job } from '@/class/model/booking/Job'
import { Charge } from '@/class/model/act/Charge'
import BookingUtil from '@/class/cargo/model/utils/BookingUtil'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'

export default {
  name: 'TabOrderInfo',
  components: {
    CargoCascader,
    cargoLeftRightResize,
    CargoButtonGroupSlider,
    cargoAdvanceSelect,
    billAddressDialog,
    cargoCompanySelect,
    cargoDepartmentNewSelect,
    cargoDepartmentSelect,
    cargoOfficeSelect,
    cargoUserSelect,
    cargoPackingSelect,
    cargoRepeatValueSelect,
    containerNoEditor,
    batchMaintenanceDialog
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: { type: String, required: true },
    viewSource: { type: String, required: false }
  },
  data() {
    return {
      URL,
      SystemConstants,
      FbaJobConstants,
      JobUtils,
      selectTypeNames: TYPE_NAMES,
      salesOfficeCheck: false, // 是否按照分公司控制 (1:开启分公司过滤 0:关闭分公司过滤)
      branchOfficeCheck: false,
      isZY: false, // 显示中邮选项
      customerCmpList: null,
      goodsViewType: 'detail',
      quantityContract: 0,
      weightContract: 0,
      cubageContract: 0,
      chargeWeightContract: 0,
      volumetricWeightContract: 0,
      bubbleCountingRatio: 0.0,
      channel4JobSelect: [],
      cargoType4JobSelect: [],
      fbaQuotation: null,
      fbaChannel: null,
      serviceChannel: null,
      chargingMethod: '',
      shippingType: '',
      destinationDistribution: '',
      bubbleSplittingRatio: 0.0,
      tenantId: 0,
      selectedLocalAddedService: [],
      localAddedService: [],
      selectedPodAddedService: [],
      podAddedService: [],
      job: new Job().fillDefaultValue().getData(),
      form: {
        fba: true,
        ams: false,
        heating: false,
        comercialInspectation: false,
        customs: false,
        signMBL: false,
        signHBL: false,
        mblOnly: false,
        salePrice: false,
        valueAddedServices: '',
        bookingNo: '',
        customerId: '',
        sales: '',
        op: '',
        quotationNo: '',
        customerContact: '',
        salesDepartment: '',
        opDepartment: '',
        warehouseNo: '',
        contactTelephone: '',
        salesOffice: this.$store.getters.currentOffice.officeId,
        opOffice: this.$store.getters.currentOffice.officeId,
        contactFax: '',
        csr: '',
        dc: '',
        csrDepartment: '',
        csrOffice: '',
        containerLoadType: 'LCL',
        operateType: 0,
        preAmazonWhTime: null,
        shippingType: 'SE',
        lob: 'SE',
        poNumber: '',
        chargingMethod: '1',
        packing: '',
        vatNo: '',
        serviceChannel: '',
        loadingPortCode: '',
        destinationDistribution: '0', // 默认卡车
        shipmentId: '',
        bubbleCountingRatio: 0.0,
        bubbleSplittingRatio: 0.0,
        cargoType: '',
        taxRegisterCountry: '',
        domesticWarehouse: '',
        warehouseCode: '',
        remoteWarehouse: false,
        incoTerm: '',
        referenceId: '',
        customsMethodPol: '',
        electric: false,
        magnetic: false,
        powdery: false,
        liquid: false,
        taxRegisterAddress: '',
        preWarehousingTime: null,
        country: '',
        zipCode: '',
        customerRequire: '',
        customsMethodPod: '',
        eoriNo: '',
        taxCompany: '',
        quantityContract: 0.0,
        weightContract: 0.0,
        cubageContract: 0.0,
        volumetricWeightContract: 0.0,
        chargeWeightContract: 0.0,
        pickupService: false,
        pickupTime: null,
        pickupDoor: '',
        doorMan: '',
        doorManTel: '',
        doorAddress: '',
        remarks: '',
        goods: [], // 箱货明细
        saleProductCode: '', // 中邮：可售卖产品
        fullOrInside: '', // 中邮：全程/国内
        address: {
          // 发货人相关
          shipperEnterpriseName: '',
          shipperCountryCode: '',
          shipperCountryName: '',
          shipperProvinceCode: '',
          shipperProvinceName: '',
          shipperCityCode: '',
          shipperCityName: '',
          shipperZipCode: '',
          shipperFax: '',
          shipperContactName: '',
          shipperContactTel: '',
          shipperContactEmail: '',
          shipperAddress1: '',
          shipperAddress2: '',
          shipperAddress3: '',
          shipperEoriNo: '',
          shipperVatNo: '',
          shipperVatNoType: '',
          // 收货人相关
          consigneeEnterpriseName: '',
          consigneeCountryCode: '',
          consigneeCountryName: '',
          consigneeProvinceCode: '',
          consigneeProvinceName: '',
          consigneeCityCode: '',
          consigneeCityName: '',
          consigneeZipCode: '',
          consigneeFax: '',
          consigneeContactName: '',
          consigneeContactTel: '',
          consigneeContactEmail: '',
          consigneeAddress1: '',
          consigneeAddress2: '',
          consigneeAddress3: '',
          consigneeEoriNo: '',
          consigneeVatNo: '',
          consigneeVatNoType: '',
          // 通知人相关
          notifyEnterpriseName: '',
          notifyCountryCode: '',
          notifyCountryName: '',
          notifyProvinceCode: '',
          notifyProvinceName: '',
          notifyCityCode: '',
          notifyCityName: '',
          notifyZipCode: '',
          notifyFax: '',
          notifyContactName: '',
          notifyContactTel: '',
          notifyContactEmail: '',
          notifyAddress1: '',
          notifyAddress2: '',
          notifyAddress3: '',
          notifyEoriNo: '',
          notifyVatNo: '',
          notifyVatNoType: ''
        }
      },
      delWarehouseInDetailKeys: [], // 删除货物明细
      // 货物明细（实际）汇总数据
      summaryGoodsDetailList: [],
      // 货物明细（实际）汇总数据与明细数据关联关系对象，key为汇总条件json
      summaryAndDetailGoodsRel: {},
      batchMaintenanceDialog: {
        visible: false,
        saveCallBack: (detailList) => {
          this.calcSingleVolumetricWeightAndChargeWeight(detailList)
          this.form.goods = this.form.goods.concat(detailList)
          this.calcContractTotal()
          this.genSummaryGoodsDetailList()
        }
      },
      containerNoEditor: {
        visible: false,
        shipmentId: '',
        boxesNumber: 0,
        key: '',
        containerNo: '',
        summarySaveCallBack: (result) => {
          const { startSeq, boxSeqLen, containerNo } = result
          const key = this.containerNoEditor.key
          const summaryGoodsDetailList = []
          // 更新箱货信息-汇总
          this.summaryGoodsDetailList.forEach(summaryGoodsDetail => {
            if (summaryGoodsDetail.key === key) {
              summaryGoodsDetail.containerNo = containerNo
            }
            summaryGoodsDetailList.push(summaryGoodsDetail)
          })
          this.summaryGoodsDetailList = summaryGoodsDetailList
          // 更新箱货信息-明细
          let index = Number(startSeq)
          this.summaryAndDetailGoodsRel[key].forEach(goodsDetail => {
            goodsDetail.containerNo = this.containerNoEditor.shipmentId + index.toString().padStart(boxSeqLen, '0')
            goodsDetail.updated = true
            index++
          })
        },
        detailSaveCallBack: (result) => {
          const { containerNo } = result
          const goodsDetailList = []
          this.form.goods.forEach(goodsDetail => {
            const key = goodsDetail.uuid ? goodsDetail.uuid : goodsDetail.tmpUuid
            if (key === this.containerNoEditor.key) {
              goodsDetail.containerNo = containerNo
              goodsDetail.updated = true
            }
            goodsDetailList.push(goodsDetail)
          })
          this.form.goods = goodsDetailList
          this.genSummaryGoodsDetailList()
        }
      },
      detailList: {
        gridApi: null,
        goodGridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          selectedRowIndex: -1,
          singleClickEdit: true,
          onCellFocused: event => {
            this.detailList.goodGridOptions.selectedRowIndex = event.rowIndex
            if (this.goodsViewSummary) {
              this.onSummaryContainerNoCellFocused(event)
            } else {
              this.onDetailContainerNoCellFocused(event)
            }
          },
          // 添加编辑组件
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridColumnEditGroup
          }
        },
        goodsColumn: [
          {
            headerName: '', width: 60, checkboxSelection: true,
            sortable: false, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true,
            pinned: 'left'
          },
          {
            headerName: this.$t('Warehouse.ContainerNo'),
            headerClass: 'blueStyle',
            field: 'containerNo', colId: 'containerNo', minWidth: 140
          },
          {
            headerName: 'Shipment Id', field: 'shipmentId', colId: 'shipmentId', minWidth: 120,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: 'Reference Id', field: 'referenceId', colId: 'referenceId', minWidth: 120,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.BoxesNumber'), field: 'boxesNumber', colId: 'boxesNumber', minWidth: 80,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0')
            }
          },
          {
            headerName: this.$t('Warehouse.SingleBoxWeight'),
            field: 'singleBoxWeight',
            colId: 'singleBoxWeight',
            minWidth: 140,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.BoxLength'), field: 'boxLength', colId: 'boxLength', minWidth: 140,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.BoxWidth'), field: 'boxWidth', colId: 'boxWidth', minWidth: 140,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.BoxHeight'), field: 'boxHeight', colId: 'boxHeight', minWidth: 140,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Pricing.ChargedWeight'), field: 'chargeWeight', colId: 'chargeWeight', minWidth: 150,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          },
          {
            headerName: this.$t('SeaExport.VolumetricWeight'),
            field: 'volumetricWeight',
            colId: 'volumetricWeight',
            minWidth: 150,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_EnglishCargoName'),
            field: 'cargoEnglishName',
            colId: 'cargoEnglishName',
            minWidth: 140,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ChineseCargoName'),
            field: 'cargoChineseName',
            colId: 'cargoChineseName',
            minWidth: 140,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.UnitRate'), field: 'unitRate', colId: 'unitRate', minWidth: 140,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.Quantity'), field: 'quantity', colId: 'quantity', minWidth: 140,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 0,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.HsCode'), field: 'hsCode', colId: 'hsCode', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.Brand'), field: 'brand', colId: 'brand', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.BrandType'), field: 'brandType', colId: 'brandType', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.ModelNo'), field: 'modelNo', colId: 'modelNo', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: 'SKU NO', field: 'skuNo', colId: 'skuNo', minWidth: 140,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: 'UPC NO', field: 'upcNo', colId: 'upcNo', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.MaterialQuality'),
            field: 'materialQuality',
            colId: 'materialQuality',
            minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.Purpose'), field: 'purpose', colId: 'purpose', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.SalesLink'), field: 'salesLink', colId: 'salesLink', minWidth: 140,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.SalesPrice'), field: 'salesPrice', colId: 'salesPrice', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.PictureUrl'), field: 'pictureUrl', colId: 'pictureUrl', minWidth: 140,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.WeightKg'), field: 'weight', colId: 'weight', minWidth: 80,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          },
          {
            headerName: 'ASIN', field: 'asin', colId: 'asin', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.CargoType'), field: 'cargoType', colId: 'cargoType', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                selectType: TYPE_NAMES.basic_data_CargoType,
                methodParams: { fbaSea: true, fbaAir: true, fbaRailway: true, collectionType: 'or' },
                tagValue: 'code',
                tagName: 'chineseName',
                filterable: true
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            },
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('FbaJob.Electric'), field: 'electric', suppressMenu: true, width: 80,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, {
                  code: true,
                  value: this.$t('SeaExport.Yes')
                }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('FbaJob.Magnetic'), field: 'magnetic', suppressMenu: true, width: 80,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, {
                  code: true,
                  value: this.$t('SeaExport.Yes')
                }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('FbaJob.Powdery'), field: 'powdery', suppressMenu: true, width: 80,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, {
                  code: true,
                  value: this.$t('SeaExport.Yes')
                }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('FbaJob.Liquid'), field: 'liquid', suppressMenu: true, width: 80,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, {
                  code: true,
                  value: this.$t('SeaExport.Yes')
                }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.ProductDescription'),
            field: 'productDescription',
            colId: 'productDescription',
            minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }
        ],
        goodsSummaryColumn: [
          {
            headerName: '', width: 60, checkboxSelection: true,
            sortable: false, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true,
            pinned: 'left'
          },
          {
            headerName: this.$t('Warehouse.ContainerNo'),
            headerClass: 'blueStyle',
            field: 'containerNo', colId: 'containerNo', minWidth: 140
          },
          {
            headerName: 'Shipment Id',
            headerClass: 'blueStyle',
            field: 'shipmentId', colId: 'shipmentId', minWidth: 120,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: 'Reference Id', field: 'referenceId', colId: 'referenceId', minWidth: 120,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.BoxesNumber'), field: 'boxesNumber', colId: 'boxesNumber', minWidth: 80,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0')
            }
          },
          {
            headerName: this.$t('Warehouse.SingleBoxWeight'),
            headerClass: 'blueStyle',
            field: 'singleBoxWeight', colId: 'singleBoxWeight', minWidth: 140,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.BoxLength'), field: 'boxLength', colId: 'boxLength', minWidth: 140,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.BoxWidth'), field: 'boxWidth', colId: 'boxWidth', minWidth: 140,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.BoxHeight'), field: 'boxHeight', colId: 'boxHeight', minWidth: 140,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Pricing.ChargedWeight'), field: 'chargeWeight', colId: 'chargeWeight', minWidth: 150,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('SeaExport.VolumetricWeight'),
            field: 'volumetricWeight',
            colId: 'volumetricWeight',
            minWidth: 150,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_EnglishCargoName'),
            field: 'cargoEnglishName',
            colId: 'cargoEnglishName',
            minWidth: 140,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ChineseCargoName'),
            field: 'cargoChineseName',
            colId: 'cargoChineseName',
            minWidth: 140,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.UnitRate'), field: 'unitRate', colId: 'unitRate', minWidth: 140,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.Quantity'), field: 'quantity', colId: 'quantity', minWidth: 140,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 0,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.HsCode'), field: 'hsCode', colId: 'hsCode', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.Brand'), field: 'brand', colId: 'brand', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.BrandType'), field: 'brandType', colId: 'brandType', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.ModelNo'), field: 'modelNo', colId: 'modelNo', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: 'SKU NO', field: 'skuNo', colId: 'skuNo', minWidth: 140,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: 'UPC NO', field: 'upcNo', colId: 'upcNo', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.MaterialQuality'),
            field: 'materialQuality',
            colId: 'materialQuality',
            minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.Purpose'), field: 'purpose', colId: 'purpose', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.SalesLink'), field: 'salesLink', colId: 'salesLink', minWidth: 140,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.SalesPrice'), field: 'salesPrice', colId: 'salesPrice', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.PictureUrl'), field: 'pictureUrl', colId: 'pictureUrl', minWidth: 140,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.WeightKg'), field: 'weight', colId: 'weight', minWidth: 80,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          },
          {
            headerName: 'ASIN', field: 'asin', colId: 'asin', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.CargoType'), field: 'cargoType', colId: 'cargoType', minWidth: 100,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                selectType: TYPE_NAMES.basic_data_CargoType,
                methodParams: { fbaSea: true, fbaAir: true, fbaRailway: true, collectionType: 'or' },
                tagValue: 'code',
                tagName: 'chineseName',
                filterable: true
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            },
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('FbaJob.Electric'), field: 'electric', suppressMenu: true, width: 80,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, {
                  code: true,
                  value: this.$t('SeaExport.Yes')
                }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('FbaJob.Magnetic'), field: 'magnetic', suppressMenu: true, width: 80,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, {
                  code: true,
                  value: this.$t('SeaExport.Yes')
                }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('FbaJob.Powdery'), field: 'powdery', suppressMenu: true, width: 80,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, {
                  code: true,
                  value: this.$t('SeaExport.Yes')
                }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('FbaJob.Liquid'), field: 'liquid', suppressMenu: true, width: 80,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, {
                  code: true,
                  value: this.$t('SeaExport.Yes')
                }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('Warehouse.ProductDescription'),
            field: 'productDescription',
            colId: 'productDescription',
            minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }
        ]
      },
      headers: {
        sessionId: this.$store.getters.token,
        ContentType: 'multipart/form-data'
      },
      exportOrderCommand: this.$t('SeaExport.batchImport'),
      doorList: [],
      matchOfRepeatDoor: options => {
        const option = options.find(p => p.contact === this.truckingInfo.doorMan)
        return option || options[0]
      },
      billAddressDialog: {
        visible: false
      },
      isSpecifiedSalesBusiness: false, // 是否启用合作伙伴对应的服务人员设置(多销售模式)
      companyList: [],
      userList: [],
      salesList: null,
      provinceOfficeLevel: -1, // 省级分公司层级
      opOfficeDisabled: false
    }
  },
  computed: {
    isVerify() { // 审核
      return this.viewSource === 'fbaVerify'
    },
    officeId() {
      return this.$store.getters.currentOfficeId
    },
    isEditing() {
      return this.action !== 'look'
    },
    isChecking() {
      return (this.form.submitState && this.form.submitState === FbaJobConstants.SUBMIT_STATE_SUBMITTED.code) && (this.form.verifyState === FbaJobConstants.VERIFY_STATE_PENDING.code || this.form.verifyState === FbaJobConstants.VERIFY_STATE_APPROVED.code ||
          this.form.verifyState === FbaJobConstants.VERIFY_STATE_REVIEWED.code)
    },
    loadingPortType() {
      let loadingPortType
      switch (this.form.shippingType) {
        case 'SE':
          loadingPortType = this.selectTypeNames.basic_data_Seaport
          break
        case 'AE':
          loadingPortType = this.selectTypeNames.basic_data_Airport
          break
        case 'RE':
          loadingPortType = this.selectTypeNames.basic_data_RailwayStation
      }
      return loadingPortType
    },
    customerEnabled() {
      return true
    },
    goodsViewSummary() {
      return this.goodsViewType === 'summary'
    },
    dynamicGoodsColumnDefs() {
      let columnDef = []
      if (this.goodsViewSummary) {
        columnDef = this.detailList.goodsSummaryColumn
      } else {
        columnDef = this.detailList.goodsColumn
      }
      return columnDef
    },
    destinations() { // 目的地 可选项
      return JobUtils.initDestination(this.fbaQuotation)
    },
    // 是否可以进行区域内委托
    isRegionalCommission() {
      return this.provinceOfficeLevel >= 0 && this.$store.getters.currentOfficeLevel >= this.provinceOfficeLevel && this.$checkPermission(['roleGroup_Common_regionalCommission'])
    },
    // 销售分公司
    salesOffice() {
      return this.form.salesOffice
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      immediate: true,
      async handler() {
        await cache.load(cacheName.CONFIG)
        this.provinceOfficeLevel = Number(cache.config.get('RegionalCommission'))
        this.salesCurrentOfficeChange()
      }
    },
    salesOffice() {
      this.salesCurrentOfficeChange()
    }
  },
  async created() {
    const user = getUserInfo()
    this.tenantId = user.tenantId
    await cache.load(cacheName.CONFIG)
    this.initConfig()
    this.initialRow()
  },
  async activated() {
    if (!this.job.charges) {
      const chargeDetails = await Job.getChargeDetails(this.job)
      this.job.charges = chargeDetails.charges
    }
  },
  methods: {
    // 销售公司或当前分公司改变
    async salesCurrentOfficeChange() {
      this.opOfficeDisabled = false
      if (this.salesOffice === this.$store.getters.currentOfficeId) {
        await cache.load(cacheName.CONFIG)
        if (cache.config.get('ToExoSystem') === 'zy') {
          if (!this.$checkPermission(['roleGroup_Common_regionalCommission'])) {
            this.setOpOffice(this.$store.getters.currentOfficeId)
            this.opOfficeDisabled = true
          }
        }
      }
    },
    // 配置参数
    initConfig() {
      this.salesOfficeCheck = Number(cache.config.get('SalesOfficeCheck')) === 1
      this.branchOfficeCheck = Number(cache.config.get('departmentSalesOfficeCheck')) === 1
      this.isSpecifiedSalesBusiness = Number(cache.config.get('IsSpecifiedSalesBusiness')) === 1
      this.isZY = String(cache.config.get('ToExoSystem')) === 'zy' // 显示中邮选项

      this.userList = getCacheListByKey(basicCacheKeys.basic_data_User)
      this.companyList = getCacheListByKey(basicCacheKeys.basic_data_Company)
    },
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }
      this.fbaQuotation = null
      this.fbaChannel = null
      this.serviceChannel = null
      this.cargoType4JobSelect = []
      this.loadSalesPrivateCustomer()
      if (this.isEditing) {
        await getJobAvailableChannels({ tenantId: this.tenantId }).then(res => {
          this.channel4JobSelect = res.data
        })
      }
      this.job = row
      if (!this.job.charges) {
        const chargeDetails = await Job.getChargeDetails(this.job)
        this.job.charges = chargeDetails.charges
      }
      if (this.action === 'add') {
        await this.initialRow(row)
        this.quantityContract = 0
        this.weightContract = Number(0).toFixed(2)
        this.cubageContract = Number(0).toFixed(3)
        this.volumetricWeightContract = Number(0).toFixed(3)
        this.chargeWeightContract = Number(0).toFixed(3)
        this.delWarehouseInDetailKeys = []
        this.summaryGoodsDetailList = []
        this.summaryAndDetailGoodsRel = {}
        this.bubbleCountingRatio = 6000.0
        this.form.bubbleCountingRatio = 6000.0
      } else {
        if (this.action === 'copy') {
          row.goods.forEach(e => { e.tmpUuid = Math.random().toString(36).slice(3) })
        }
        this.form = row
        if (this.form.bubbleCountingRatio || typeof this.form.bubbleCountingRatio === 'number') {
          this.bubbleCountingRatio = Number(this.form.bubbleCountingRatio)
        } else {
          this.bubbleCountingRatio = 6000.0
          this.form.bubbleCountingRatio = 6000.0
        }
        await this.changeChannelName(this.form.serviceChannel)
        this.serviceChannel = this.form.serviceChannel
        this.quantityContract = Number(this.form.quantityContract || 0)
        this.weightContract = Number(this.form.weightContract || 0).toFixed(2)
        this.cubageContract = Number(this.form.cubageContract || 0).toFixed(3)
        this.chargeWeightContract = Number(this.form.chargeWeightContract || 0).toFixed(3)
        this.volumetricWeightContract = Number(this.form.volumetricWeightContract || 0).toFixed(3)
        this.calcContractTotal(true)
        this.genSummaryGoodsDetailList()
        await this.loadSites()
      }
      this.chargingMethod = this.form.chargingMethod
      this.shippingType = this.form.shippingType
      this.destinationDistribution = this.form.destinationDistribution
      this.bubbleCountingRatio = this.form.bubbleCountingRatio
      this.bubbleSplittingRatio = this.form.bubbleSplittingRatio
      this.getCargoType()
      this.initAddedService()
    },
    // 初始记录
    initialRow(curRow) {
      const newRow = {
        fba: true,
        ams: false,
        heating: false,
        comercialInspectation: false,
        customs: false,
        signMBL: false,
        signHBL: false,
        mblOnly: false,
        salePrice: false,
        bookingNo: '',
        customerId: '',
        sales: '',
        valueAddedServices: '',
        op: '',
        quotationNo: '',
        customerContact: '',
        salesDepartment: '',
        opDepartment: '',
        warehouseNo: '',
        contactTelephone: '',
        salesOffice: this.$store.getters.currentOffice.officeId,
        opOffice: this.$store.getters.currentOffice.officeId,
        contactFax: '',
        csr: '',
        dc: '',
        csrDepartment: '',
        csrOffice: '',
        containerLoadType: 'LCL',
        operateType: 0,
        preAmazonWhTime: null,
        shippingType: 'SE',
        lob: 'SE',
        poNumber: '',
        chargingMethod: '1',
        packing: '',
        vatNo: '',
        serviceChannel: '',
        loadingPortCode: '',
        destinationDistribution: '0', // 默认卡车
        shipmentId: '',
        bubbleCountingRatio: 6000.0,
        bubbleSplittingRatio: 0.0,
        cargoType: '',
        taxRegisterCountry: '',
        domesticWarehouse: '',
        warehouseCode: '',
        remoteWarehouse: false,
        incoTerm: '',
        referenceId: '',
        customsMethodPol: '',
        electric: false,
        magnetic: false,
        powdery: false,
        liquid: false,
        taxRegisterAddress: '',
        preWarehousingTime: null,
        country: '',
        zipCode: '',
        customerRequire: '',
        customsMethodPod: '',
        eoriNo: '',
        taxCompany: '',
        quantityContract: 0.0,
        weightContract: 0.0,
        cubageContract: 0.0,
        volumetricWeightContract: 0.0,
        chargeWeightContract: 0.0,
        pickupService: false,
        pickupTime: null,
        pickupDoor: '',
        doorMan: '',
        doorManTel: '',
        doorAddress: '',
        remarks: '',
        goods: [], // 箱货明细
        address: {
          // 发货人相关
          shipperEnterpriseName: '',
          shipperCountryCode: '',
          shipperCountryName: '',
          shipperProvinceCode: '',
          shipperProvinceName: '',
          shipperCityCode: '',
          shipperCityName: '',
          shipperZipCode: '',
          shipperFax: '',
          shipperContactName: '',
          shipperContactTel: '',
          shipperContactEmail: '',
          shipperAddress1: '',
          shipperAddress2: '',
          shipperAddress3: '',
          shipperEoriNo: '',
          shipperVatNo: '',
          shipperVatNoType: '',
          // 收货人相关
          consigneeEnterpriseName: 'Amazon',
          consigneeCountryCode: '',
          consigneeCountryName: '',
          consigneeProvinceCode: '',
          consigneeProvinceName: '',
          consigneeCityCode: '',
          consigneeCityName: '',
          consigneeZipCode: '',
          consigneeFax: '',
          consigneeContactName: '',
          consigneeContactTel: '',
          consigneeContactEmail: '',
          consigneeAddress1: '',
          consigneeAddress2: '',
          consigneeAddress3: '',
          consigneeEoriNo: '',
          consigneeVatNo: '',
          consigneeVatNoType: '',
          // 通知人相关
          notifyEnterpriseName: '',
          notifyCountryCode: '',
          notifyCountryName: '',
          notifyProvinceCode: '',
          notifyProvinceName: '',
          notifyCityCode: '',
          notifyCityName: '',
          notifyZipCode: '',
          notifyFax: '',
          notifyContactName: '',
          notifyContactTel: '',
          notifyContactEmail: '',
          notifyAddress1: '',
          notifyAddress2: '',
          notifyAddress3: '',
          notifyEoriNo: '',
          notifyVatNo: '',
          notifyVatNoType: ''
        }
      }
      for (const key in newRow) {
        curRow[key] = newRow[key]
      }
      this.form = curRow
      console.log('newRow', this.form)
    },
    initialGoodRow() {
      const newRow = {
        sequenceNo: 0,
        containerNo: '',
        poNumber: '',
        shipmentId: '',
        referenceId: '',
        boxesNumber: 0,
        singleBoxWeight: 0.0,
        boxLength: 0.0,
        boxWidth: 0.0,
        boxHeight: 0.0,
        chargeWeight: 0.0,
        volumetricWeight: 0.0,
        cargoEnglishName: '',
        cargoChineseName: '',
        currency: '',
        unitRate: 0.0,
        quantity: 0.0,
        hsCode: '',
        brand: '',
        brandType: '',
        modelNo: '',
        skuNo: '',
        upcNo: '',
        materialQuality: '',
        purpose: '',
        salesLink: '',
        salesPrice: 0.0,
        originPlace: '',
        pictureUrl: '',
        weight: 0.0,
        asin: '',
        cargoType: '',
        electric: false,
        magnetic: false,
        powdery: false,
        liquid: false,
        productDescription: ''
      }
      console.log('newRow', newRow)
      return newRow
    },
    async customerIdChangeHandler(company) {
      this.form.customerContact = ''
      this.form.contactTelephone = ''
      this.form.contactFax = ''
      if (!company.cmpIdx) {
        this.form.customerId = 0
        this.form.sales = 0// 销售
        this.form.salesDepartment = 0// 销售部门
        this.form.salesOffice = 0// 销售分公司
        // 如果开启分公司过滤参数，查出来所有分公司
        let officeSaleList
        if (this.salesOfficeCheck) {
          officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.$store.getters.currentOfficeId)
        } else {
          officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', null, true)
        }
        this.salesList = officeSaleList
        return
      }
      this.form.customerId = company.cmpIdx
      // 联系人
      this.contactList = await Company.loadContact(company.uuid)
      const contact = this.getDefaultContact(this.contactList)
      if (contact) {
        this.form.customerContact = contact.contactPerson
        this.form.contactTelephone = contact.telephone
        this.form.contactFax = contact.fax
      }
      if (this.form.customerId) this.loadSites()
      this.loadCompanyUser() // 销售
      if (this.form.serviceChannel && this.chargeWeightContract && this.chargeWeightContract > 0) {
        await this.$confirm(this.$t('FbaJob.changeCustomer'), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          cancelButtonText: this.$t('CargoMsg.Cargo_No'),
          type: 'warning'
        }).then(() => {
          // 刷新费用
          this.refreshCharge()
        }).catch(() => {
        })
      }
    },
    loadCompanyUser() {
      const company = this.companyList.find(p => p.cmpIdx === this.form.customerId)
      if (company) {
        if (this.isSpecifiedSalesBusiness) {
          Company.getCompanyUsers(company.uuid).then(data => {
            this.loadCompanyUserHandler(data)
          })
        } else {
          this.loadCustomerDetailSales(company)
        }
      }
    },
    /**
     * 自揽货 -> 加载销售(如果合作伙伴服务人员有多个则不刷新)
     */
    async loadCustomerDetailSales(company) {
      if (!this.isSpecifiedSalesBusiness) {
        const customerDetail = await Company.loadCustomer(company.uuid).then(list => list.length > 0 ? list[0] : null)
        if (customerDetail) {
          const saleTemp = customerDetail.sales
          const user = this.userList.find(p => p.userId === saleTemp)
          if (user && user.active) {
            this.salesChangeHandler({ ...user, value: saleTemp })
          }
        } else {
          this.salesChangeHandler({ value: 0 })
        }
      }
    },
    async loadCompanyUserHandler(companyUsers) {
      const job = this.form
      // 销售
      const salesList = []
      let salesDefaultId = 0
      // 客服
      const csrList = []
      let csrDefaultId = 0
      // 单证
      const dcList = []
      let dcDefaultId = 0
      // 如果开启分公司过滤参数，查出来所有分公司
      let officeSaleList
      if (this.salesOfficeCheck) {
        officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.$store.getters.currentOfficeId)
      }
      officeSaleList = officeSaleList || []
      if (companyUsers && companyUsers.length > 0) {
        let lob = SystemConstants.FBA_SE.code
        switch (this.form.shippingType) {
          case 'SE':
            lob = SystemConstants.FBA_SE.code
            break
          case 'AE':
            lob = SystemConstants.FBA_AE.code
            break
          case 'RE':
            lob = SystemConstants.FBA_RE.code
        }
        for (const u of companyUsers) {
          if (!u.lob || u.lob === lob || u.lob === 'ALL') {
            const user = this.userList.find(p => p.userId === u.userId)
            if (user && user.active) {
              if (u.roleType === CargoOfRoleType.SALES_TYPE.code) { // 销售
                if (this.salesOfficeCheck) {
                  for (const obj of officeSaleList) {
                    if (user.userId === obj.userId) {
                      if (u.defaultUser) {
                        salesDefaultId = u.userId
                      }
                      salesList.push(user)
                    }
                  }
                } else {
                  if (u.defaultUser) {
                    salesDefaultId = u.userId
                  }
                  salesList.push(user)
                }
              } else if (u.roleType === CargoOfRoleType.CSR_TYPE.code) { // 客服
                if (u.defaultUser) {
                  csrDefaultId = u.userId
                }
                csrList.push(user)
              } else if (u.roleType === CargoOfRoleType.DOC_TYPE.code) { // 单证
                if (u.defaultUser) {
                  dcDefaultId = u.userId
                }
                dcList.push(user)
              }
            }
          }
        }
      }
      this.salesList = salesList
      if (salesList.length > 0) {
        this.salesList = salesList
        if (salesDefaultId > 0) {
          job.sales = salesDefaultId
        } else {
          job.sales = salesList[0].userId
        }
        this.$nextTick(() => {
          const user = this.userList.find(p => p.userId === job.sales)
          this.salesChangeHandler({ ...user, value: user.userId })
        })
      } else {
        job.sales = 0
        job.salesDepartment = 0
        job.salesOffice = 0
      }
      // 客服
      if (csrList.length > 0) {
        if (csrDefaultId > 0) {
          job.csr = csrDefaultId
        } else {
          job.csr = csrList[0].userId
        }
        this.$nextTick(() => {
          const user = this.userList.find(p => p.userId === job.csr)
          this.csrChangeHandler({ ...user, value: user.userId })
        })
      } else {
        job.csr = 0
        job.csrDepartment = 0
      }
      // 单证
      if (dcList.length > 0) {
        if (dcDefaultId > 0) {
          job.dc = dcDefaultId
        } else {
          job.dc = dcList[0].userId
        }
        this.$nextTick(() => {
          const user = this.userList.find(p => p.userId === job.dc)
          this.dcChangeHandler({ ...user, value: user.userId })
        })
      } else {
        job.dc = 0
        job.dcDepartment = 0
      }
    },
    getDefaultContact(contactList) {
      if (!contactList || contactList.length <= 0) return ''
      const c = contactList.find(item => item.defaultContact)
      return c || contactList[0]
    },
    downLoadDetail() {
      ExportUtils.downloadTemplateFile('ImportCaseGoodsDetail.xlsx', 'fba')
    },
    loadSalesPrivateCustomer() {
      const user = getUserInfo()
      const companyList = getCacheListByKey(basicCacheKeys.basic_data_Company)
      this.customerCmpList = null
      if (!user.admin && !this.$checkPermission(['button_FBAOrder_selectAllCustomerFBA']) && (this.$checkPermission(['button_FBAOrder_selectSalesCustomerFBA']) || this.$checkPermission(['button_FBAOrder_selectDepartmentCustomerFBA']))) {
        getFbaCustomerByRole({ branch: this.$store.getters.currentOfficeId }).then(res => {
          this.customerCmpList = companyList.filter(p => res.data.includes(p.cmpIdx) && p.customer && p.fba && p.active)
        })
      }
    },
    downLoadSummary() {
      ExportUtils.downloadTemplateFile('ImportCaseGoodsSummary.xlsx', 'fba')
    },
    getSubmitData() {
      // 保存前校验
      this.checkSubmitData()
      if (this.form.tabCostApi) {
        this.form.tabCostApi = undefined
      }
      return this.form
    },
    addedServiceChangeHandler() {
      this.form.valueAddedServices = this.selectedLocalAddedService.concat(this.selectedPodAddedService).join(',')
    },
    singleAddedServiceChangeHandler(val, item) {
      this.form[item.code] = val
    },
    initAddedService() {
      this.localAddedService = []
      this.podAddedService = []
      this.selectedLocalAddedService = []
      this.selectedPodAddedService = []
      // 初始化增值服务
      let valueAddedServices = []
      if (this.form.valueAddedServices && this.form.valueAddedServices.split(',').length > 0) {
        valueAddedServices = this.form.valueAddedServices.split(',')
      }
      const res = getSpecificBasicDataFromCache(this.selectTypeNames.basic_data_ValueAddedService)
      for (const item of res) {
        if ((this.form.shippingType === 'SE' && item.fbaSea) || (this.form.shippingType === 'AE' && item.fbaAir) || (this.form.shippingType === 'RE' && item.fbaRailway)) {
          switch (Number(item.serviceType)) {
            case 0:
              this.localAddedService.push(item)
              if (valueAddedServices.indexOf(item.code) >= 0) {
                this.form[item.code] = true
                this.selectedLocalAddedService.push(item.code)
              }
              break
            case 1:
              this.podAddedService.push(item)
              if (valueAddedServices.indexOf(item.code) >= 0) {
                this.form[item.code] = true
                this.selectedPodAddedService.push(item.code)
              }
              break
          }
        }
      }
    },
    async salesChangeHandler(data) {
      this.form.sales = data.value
      this.form.salesOffice = 0
      this.form.salesDepartment = 0
      if (data.value) {
        if (data.defaultOfficeId) { // 用户设置了默认公司和部门就用默认的
          this.form.salesOffice = data.defaultOfficeId
          this.form.salesDepartment = data.defaultDepId
        } else {
          const offices = await User.getUserDepartmentOffices('role', 'sales', data.value)
          if (offices.length > 1) {
            for (const item of offices) {
              if (this.branchOfficeCheck || (!this.branchOfficeCheck && item.officeId === this.$store.getters.currentOfficeId)) {
                this.form.salesOffice = item.officeId
                this.form.salesDepartment = item.departmentId
                break
              }
            }
          } else {
            const user = new User(data)
            const department = await user.getDefaultDepartment('role', 'sales')
            this.form.salesDepartment = department ? department.departmentId : 0
            const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
            if (office) {
              this.form.salesOffice = office.officeId
            }
          }
        }
      }
    },
    async csrChangeHandler(data) {
      this.form.csr = data.value
      this.form.csrDepartment = 0
      this.form.csrOffice = 0
      if (data.value) {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'csr')
        if (dep) {
          this.form.csrDepartment = dep.departmentId
          const office = await Office.getOfficeByUuid(dep.officeUuid)
          this.form.csrOffice = office ? office.officeId : 0
        }
      }
    },
    opChangeHandler(user) {
      if (user.defaultDepId > 0) {
        this.form.opDepartment = user.defaultDepId
      } else {
        if (this.form.opOffice > 0) {
          new User(user).getUserDefaultDepartmentByOffice('role', 'op', this.form.opOffice).then(dep => {
            this.form.opDepartment = dep ? dep.departmentId : 0
          })
        } else {
          new User(user).getDefaultDepartment('role', 'op', this.form.opOffice).then(dep => {
            this.form.opDepartment = dep ? dep.departmentId : 0
          })
        }
      }
    },
    async dcChangeHandler(data) {
      this.form.dc = data.value
      this.form.dcDepartment = 0
      this.form.dcOffice = 0
      if (data.value) {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'doc')
        this.form.dcDepartment = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        this.form.dcOffice = office ? office.officeId : 0
      } else {
        this.form.dc = 0
        this.form.dcDepartment = 0
        this.form.dcOffice = 0
      }
    },
    updateTooltip(ref) {
      this.$nextTick(() => {
        if (ref === 'remarksTip' || ref === 'customerRequireTip') {
          this.$refs[ref].updatePopper()
        }
      })
    },
    doorsChangeHandler(value, option) {
      this.form.pickupDoor = value
      this.form.doorMan = ''
      this.form.doorManTel = ''
      this.form.doorAddress = ''
      if (option) {
        this.form.doorMan = option.contact
        this.form.doorManTel = option.phone
        this.form.doorAddress = option.address
      }
    },
    // 门点地址
    async loadSites() {
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.form.customerId))
      if (!companyCache) return
      const companyUuid = companyCache.uuid
      if (!companyUuid) return
      await getSites(companyUuid).then(res => {
        this.doorList = res.data
      })
    },

    selectCargoItem(item) {
      this.address[item.key] = item.value
      if (item.key === 'shipperCountryCode') {
        // 根据二字码查询国家
        // let countryUuid = ''
        if (this.form.address.shipperCountryCode) {
          const country = getObjectByCache(basicCacheKeys.basic_data_Country, 'code', this.form.address.shipperCountryCode)
          if (country) {
            // countryUuid = country.uuid
            this.form.address.shipperCountryName = country.chineseName
          }
        }
        // 国家为空清空省市
        if (!this.form.address.shipperCountryCode) {
          this.form.address.shipperCountryName = ''
          // this.form.address.shipperProvinceCode = ''
          // this.form.address.shipperProvinceName = ''
          // this.form.address.shipperCityCode = ''
          // this.form.address.shipperCityName = ''
        }
        // 初始化省份信息
        // this.getDivisionByParentId(countryUuid, 1)
      } else if (item.key === 'shipperProvinceCode') {
        // this.getDivisionByParentCode(this.form.address.shipperProvinceCode, 2)
        // 省为空清空市
        // if (!this.form.address.shipperProvinceCode) {
        //   this.form.address.shipperProvinceName = ''
        //   this.form.address.shipperCityCode = ''
        //   this.form.address.shipperCityName = ''
        // }
      } else if (item.key === 'shipperCityCode') {
        // 省为空清空市
        // if (!this.form.address.shipperCityCode) {
        //   this.form.address.shipperCityName = ''
        // }
      } else if (item.key === 'consigneeCountryCode') {
        // 根据二字码查询国家
        // let countryUuid = ''
        if (this.form.address.consigneeCountryCode) {
          const country = getObjectByCache(basicCacheKeys.basic_data_Country, 'code', this.form.address.consigneeCountryCode)
          if (country) {
            // countryUuid = country.uuid
            this.form.address.consigneeCountryName = country.chineseName
          }
        }
        // 国家为空清空省市
        if (!this.form.address.consigneeCountryCode) {
          this.form.address.consigneeCountryName = ''
        }
      } else if (item.key === 'notifyCountryCode') {
        // 根据二字码查询国家
        // let countryUuid = ''
        if (this.form.address.notifyCountryCode) {
          const country = getObjectByCache(basicCacheKeys.basic_data_Country, 'code', this.form.address.notifyCountryCode)
          if (country) {
            // countryUuid = country.uuid
            this.form.address.notifyCountryName = country.chineseName
          }
        }
        // 国家为空清空省市
        if (!this.form.address.notifyCountryCode) {
          this.form.address.notifyCountryName = ''
        }
      }
    },
    // 根据parentId获取区域信息 parentId 父级ID type 1.省份;2.城市;3.地区
    getDivisionByParentId(parentId, type) {
      let data = []
      if (parentId) {
        data = getObjectByCache(basicCacheKeys.basic_data_AdministrativeDivision, 'parentId', parentId)
      }
      switch (type) {
        case 1:
          this.provinceList = data
          break
        case 2:
          this.cityList = data
          break
        case 3:
          this.districtList = data
          break
        default:
          break
      }
    },
    /**
     * 根据父级代码获取区域信息
     * @param parentCode 父级代码
     * @param type 2.城市;3.地区
     */
    getDivisionByParentCode(parentCode, type) {
      let provinces = []
      let cities = []
      switch (type) {
        case 2:
          provinces = this.provinceList.filter(p => p.code === parentCode)
          if (provinces.length > 0) {
            this.getDivisionByParentId(provinces[0].uuid, type)
          } else {
            this.cityList = []
          }
          break
        case 3:
          cities = this.cityList.filter(p => p.code === parentCode)
          if (cities.length > 0) {
            this.getDivisionByParentId(cities[0].uuid, type)
          } else {
            this.districtList = []
          }
          break
        default:
          break
      }
    },
    // 加入货物
    addDetailHandler() {
      const row = this.initialGoodRow()
      row.sequenceNo = this.form.goods ? this.form.goods.length + 1 : 1
      row.boxesNumber = 1
      row.updated = true
      row.tmpUuid = Math.random().toString(36).slice(3)
      this.form.goods.push(row)
      this.calcContractTotal()
    },
    getCargoType() {
      this.cargoType4JobSelect = []
      const res = getSpecificBasicDataFromCache(this.selectTypeNames.basic_data_CargoType)
      let acceptableGoods = []
      if (this.fbaQuotation) {
        acceptableGoods = this.fbaQuotation.acceptableGoods.split(',')
      }
      for (const item of res) {
        if (this.fbaQuotation) {
          const valid = acceptableGoods && acceptableGoods.length > 0 && acceptableGoods.indexOf(item.code) > -1
          if (!valid) {
            continue
          }
        }
        switch (this.form.shippingType) {
          case 'SE':
            if (item.fbaSea) {
              this.cargoType4JobSelect.push(item)
            }
            break
          case 'AE':
            if (item.fbaAir) {
              this.cargoType4JobSelect.push(item)
            }
            break
          case 'RE':
            if (item.fbaRailway) {
              this.cargoType4JobSelect.push(item)
            }
            break
          default:
            if (item.fbaSea || item.fbaAir || item.fbaRailway) {
              this.cargoType4JobSelect.push(item)
            }
        }
      }
      if (this.form.cargoType && this.cargoType4JobSelect.map(item => item.code).indexOf(this.form.cargoType) === -1) {
        this.form.cargoType = ''
      }
    },
    // 更改服务渠道
    async changeServiceChannel(channel) {
      if (!channel) {
        this.serviceChannel = null
        this.fbaChannel = null
        this.fbaQuotation = null
        this.form.fbaChannel = this.fbaChannel
        this.form.fbaQuotation = this.fbaQuotation
        return
      }
      let update = false
      let refreshCharge = false
      if (typeof this.form.customerId === 'number' && this.form.customerId > 0) {
        await this.changeChannelName(channel)
        const containCustomer = await this.checkChangeChannel()
        if (containCustomer) {
          if (typeof this.form.warehouseCode === 'string' && this.form.warehouseCode) {
            // 判断区中是否包含该目的地
            if (this.checkWarehouseCode()) {
              // 判断计费重量是否有值
              if (this.form.customerId && this.chargeWeightContract && this.chargeWeightContract > 0) {
                await this.$confirm(this.$t('FbaJob.refreshCharge'), this.$t('Message.Tips'), {
                  confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
                  cancelButtonText: this.$t('CargoMsg.Cargo_No'),
                  type: 'warning'
                }).then(() => {
                  refreshCharge = true
                }).catch(() => {
                })
              }
            } else {
              await this.$alert(StrUtils.substitute(this.$t('FbaJob.cargoTypeNotExist'), this.form.warehouseCode), this.$t('Message.Tips'), {
                confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
                type: 'warning'
              })
              this.form.warehouseCode = ''
            }
          }
          update = true
        } else {
          await this.$confirm(this.$t('FbaJob.changeChannel'), this.$t('Message.Tips'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
            cancelButtonText: this.$t('CargoMsg.Cargo_No'),
            type: 'warning'
          }).then(async() => {
            update = true
            if (!this.checkWarehouseCode()) {
              this.form.warehouseCode = ''
            }
          }).catch(async() => {
            this.form.serviceChannel = this.serviceChannel
            await this.changeChannelName(this.serviceChannel)
            return Promise.reject(this.$t('Message.EditCancelled'))
          })
        }
      } else {
        if (typeof this.form.warehouseCode === 'string' && this.form.warehouseCode) {
          // 判断区中是否包含该目的地
          if (!this.checkWarehouseCode()) {
            await this.$alert(StrUtils.substitute(this.$t('FbaJob.cargoTypeNotExist'), this.form.warehouseCode), this.$t('Message.Tips'), {
              confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
              type: 'warning'
            })
            this.form.warehouseCode = ''
          }
        }
        update = true
      }
      if (update) {
        this.serviceChannel = channel
        await this.changeChannelName(channel)
        await this.checkCargoType()
        if (this.fbaChannel) {
          this.syncJobInfoByChannel()
        }
        this.getCargoType()
        this.initAddedService()
        if (this.form.goods && this.form.goods.length > 0) {
          this.calcSingleVolumetricWeightAndChargeWeight(this.form.goods)
          this.calcContractTotal()
          this.genSummaryGoodsDetailList()
        } else {
          this.calcVolumetricAndChargeWeight()
        }
      }
      if (refreshCharge) {
        // 刷新费用
        await this.refreshCharge()
      }
    },
    // 更新渠道同步业务字段
    syncJobInfoByChannel() {
      this.form.chargingMethod = this.fbaChannel.chargingMethod + ''
      this.form.shippingType = this.fbaChannel.shippingType
      this.form.lob = this.fbaChannel.shippingType
      this.form.destinationDistribution = this.fbaChannel.destinationDistribution + ''
      this.form.bubbleCountingRatio = this.fbaChannel.bubbleCountingRatio
      this.form.bubbleSplittingRatio = this.fbaChannel.bubbleSplittingRatio
      this.chargingMethod = this.form.chargingMethod
      this.shippingType = this.form.shippingType
      this.destinationDistribution = this.form.destinationDistribution
      this.bubbleCountingRatio = this.form.bubbleCountingRatio
      this.bubbleSplittingRatio = this.form.bubbleSplittingRatio
    },
    // 更改目的地
    async changeWarehouseCode() {
      if (this.form.goods && this.form.goods.length > 0) {
        this.calcSingleVolumetricWeightAndChargeWeight(this.form.goods)
        this.calcContractTotal()
        this.genSummaryGoodsDetailList()
      } else {
        this.calcVolumetricAndChargeWeight()
      }
      if (this.form.customerId && this.form.serviceChannel && this.chargeWeightContract && this.chargeWeightContract > 0) {
        await this.$confirm(this.$t('FbaJob.changeWarehouseCode'), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          cancelButtonText: this.$t('CargoMsg.Cargo_No'),
          type: 'warning'
        }).then(() => {
          // 刷新费用
          this.refreshCharge()
        }).catch(() => {
        })
      }
    },
    // 刷新费用
    async refreshCharge() {
      let authorizationValue = null
      let customers = []
      // 查找对应运价级别的客户
      for (const e of this.fbaQuotation.customerPriceList) {
        const item = { anyInteger: e.quotationObject }
        await searchCustomerPrice(item).then(res => {
          const result = res.data || []
          customers = customers.concat(result)
        })
      }
      if (customers && customers.length > 0) {
        for (const customer of customers) {
          if (Number(this.form.customerId) === Number(customer.CMP_IDX)) {
            authorizationValue = customer.AUTHORIZATION_VALUE
            break
          }
        }
      }
      if (authorizationValue) {
        const params = {
          fbaChannel: this.fbaChannel,
          fbaQuotation: this.fbaQuotation,
          quantity: this.form.quantityContract,
          weight: this.form.weightContract,
          cubage: this.form.cubageContract,
          volumetricWeight: this.form.volumetricWeightContract,
          chargeWeight: Number(this.chargeWeightContract),
          warehouseCode: this.form.warehouseCode,
          authorizationValue: authorizationValue
        }
        const fbaChargeInfo = FbaQuotationUtil.getFbaChargeInfo(params)
        if (fbaChargeInfo) {
          fbaChargeInfo.authorizationValue = authorizationValue
        }
        const fbaAdditionalChargeInfo = FbaQuotationUtil.getFbaAdditionalChargeInfo(params)
        if (fbaAdditionalChargeInfo) {
          fbaAdditionalChargeInfo.authorizationValue = authorizationValue
        }
        if (this.job.charges && this.job.charges.length > 0) {
          let matchCharge = false
          const chargeList = []
          let matchAdditionalCharge = false
          const additionalChargeList = []
          for (const item of this.job.charges) {
            if (fbaChargeInfo) {
              const chargeItemIdSe = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'zhName', '海运费', 'itemId')
              const chargeItemIdAe = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'zhName', '空运费', 'itemId')
              const chargeItemIdRe = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'zhName', '运费', 'itemId')
              if (item.chargeItemId === chargeItemIdSe || item.chargeItemId === chargeItemIdAe || item.chargeItemId === chargeItemIdRe) {
                matchCharge = true
                chargeList.push(item)
              }
            }
            if (fbaAdditionalChargeInfo) {
              const chargeItemList = getCacheListByKey(basicCacheKeys.basic_data_ChargeItem)
              const matchList = chargeItemList.filter(p => (item.chargeItemId === p.itemId) && p.surcharge)
              if (matchList && matchList.length > 0) {
                matchAdditionalCharge = true
                additionalChargeList.push(item)
              }
            }
          }
          if (matchCharge) {
            this.updateCharge(fbaChargeInfo, chargeList)
          } else {
            await this.createCharge(fbaChargeInfo)
          }
          if (matchAdditionalCharge) {
            this.updateCharge(fbaAdditionalChargeInfo, additionalChargeList, true)
          } else {
            await this.createCharge(fbaAdditionalChargeInfo, true)
          }
        } else {
          if (fbaChargeInfo) {
            await this.createCharge(fbaChargeInfo)
          }
          if (fbaAdditionalChargeInfo) {
            await this.createCharge(fbaAdditionalChargeInfo, true)
          }
        }
      }
    },
    // 更新费用
    updateCharge(fbaChargeInfo, chargeList, additional = false) {
      for (const item of chargeList) {
        if (!item.confirmBillUuid &&
            !item.invoiceUuid && !item.billingUuid && !item.billingPaymentUuid &&
            !item.verifiedAmount && !item.paidOff && item.chargeState === 0 &&
            ((item.receivable && this.job.receivableChargeLockedStatus === 0) || (!item.receivable && this.job.payableChargeLockedStatus === 0))) {
          if (fbaChargeInfo) {
            item.chargeItemId = fbaChargeInfo.chargeItemId
            item.currency = fbaChargeInfo.currency
            item.quantity = fbaChargeInfo.quantity
            item.unitRate = fbaChargeInfo.unitRate
            item.amount = fbaChargeInfo.amount
            item.excludingTaxAmount = fbaChargeInfo.excludingTaxAmount
            item.measure = fbaChargeInfo.measure
            item.accountId = this.form.customerId
            ChargeUtils.calculateTax(item, item.quantity * item.unitRate, item.taxRate, true)
            ChargeUtils.getChargeisOverseaNotControlledByConfig(item)
            const localCurrency = RateUtil.localCurrencyByOffice()
            let remarks = ''
            if (additional) {
              remarks = '服务渠道：' + this.form.serviceChannel + '\n' +
                  '费用类型：' + fbaChargeInfo.calcMethodStr + '\n' +
                  '预估金额：' + fbaChargeInfo.estimatedAmountStr + '\n' +
                  '折合' + localCurrency + '：' + FbaQuotationUtil.conversionRMBLabel(item)
            } else {
              remarks = '服务渠道：' + this.form.serviceChannel + '\n' +
                  '运价级别：' + ColumnUtils.QuotationObjectLabelFunc(Number(fbaChargeInfo.authorizationValue)) + '\n' +
                  '计费重量：' + this.chargeWeightContract + '\n' +
                  '计算方式：' + fbaChargeInfo.calcMethodStr + '\n' +
                  '预估金额：' + fbaChargeInfo.estimatedAmountStr + '\n' +
                  '折合' + localCurrency + '：' + FbaQuotationUtil.conversionRMBLabel(item)
            }
            item.remarks = remarks
          }
        }
      }
      if (this.job.tabCostApi) {
        this.job.tabCostApi.refreshCells({ force: true })
      }
    },
    // 新增费用
    async createCharge(fbaChargeInfo, additional = false) {
      if (fbaChargeInfo) {
        const charge = new Charge().fillDefaultValue().getData()
        charge.chargeItemId = fbaChargeInfo.chargeItemId
        charge.currency = fbaChargeInfo.currency
        charge.quantity = fbaChargeInfo.quantity
        charge.unitRate = fbaChargeInfo.unitRate
        charge.amount = fbaChargeInfo.amount
        charge.excludingTaxAmount = fbaChargeInfo.excludingTaxAmount
        charge.measure = fbaChargeInfo.measure
        charge.accountId = this.form.customerId
        await BookingUtil.getNewCharge(charge, this.job, true)
        ChargeUtils.getChargeisOverseaNotControlledByConfig(charge)
        const localCurrency = RateUtil.localCurrencyByOffice()
        let remarks = ''
        if (additional) {
          remarks = '服务渠道：' + this.form.serviceChannel + '\n' +
              '费用类型：' + fbaChargeInfo.calcMethodStr + '\n' +
              '预估金额：' + fbaChargeInfo.estimatedAmountStr + '\n' +
              '折合' + localCurrency + '：' + FbaQuotationUtil.conversionRMBLabel(charge)
        } else {
          remarks = '服务渠道：' + this.form.serviceChannel + '\n' +
              '运价级别：' + ColumnUtils.QuotationObjectLabelFunc(Number(fbaChargeInfo.authorizationValue)) + '\n' +
              '计费重量：' + this.chargeWeightContract + '\n' +
              '计算方式：' + fbaChargeInfo.calcMethodStr + '\n' +
              '预估金额：' + fbaChargeInfo.estimatedAmountStr + '\n' +
              '折合' + localCurrency + '：' + FbaQuotationUtil.conversionRMBLabel(charge)
        }
        charge.remarks = remarks
        this.context.reloadCharge = true
      }
    },
    // 判断区中是否包含该目的地
    checkWarehouseCode() {
      let result = false
      if (this.fbaQuotation) {
        const partitionSettingList = this.fbaQuotation.partitionSettingList
        let warehouseCode = []
        for (const item of partitionSettingList) {
          const pod = item.pod
          if (pod && pod.split(',').length > 0) {
            warehouseCode = warehouseCode.concat(pod.split(','))
          }
        }
        result = warehouseCode.indexOf(this.form.warehouseCode) > -1
      }
      return result
    },
    // 判断可接货物是否包含当前货物类型
    async checkCargoType() {
      const acceptableGoodsStr = this.fbaQuotation?.acceptableGoods
      let acceptableGoods = []
      if (acceptableGoodsStr && acceptableGoodsStr.split(',').length > 0) {
        acceptableGoods = acceptableGoodsStr.split(',')
      }
      if (acceptableGoods.indexOf(this.form.cargoType) === -1 && this.form.cargoType) {
        const acceptableGoodsTag = ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_CargoType, 'code', this.form.cargoType, 'chineseName')
        await this.$alert(StrUtils.substitute(this.$t('FbaJob.cargoTypeNotExist'), acceptableGoodsTag), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          type: 'warning'
        })
        this.form.cargoType = ''
      }
    },
    // 判断是否更新渠道
    async checkChangeChannel() {
      let customers = []
      let containCustomer = false
      // 查找对应运价级别的客户
      if (this.fbaQuotation) {
        for (const e of this.fbaQuotation.customerPriceList) {
          const item = { anyInteger: e.quotationObject }
          await searchCustomerPrice(item).then(res => {
            const result = res.data || []
            customers = customers.concat(result)
          })
        }
        if (customers && customers.length > 0) {
          for (const customer of customers) {
            if (Number(this.form.customerId) === Number(customer.CMP_IDX)) {
              containCustomer = true
              break
            }
          }
        }
      }
      return containCustomer
    },
    async changeChannelName(channelName) {
      const channel = this.channel4JobSelect.find(e => channelName === e.channelName)
      if (channel) {
        this.fbaChannel = channel
        this.fbaQuotation = new FbaQuotation().fillDefaultValue().getData()
        this.fbaQuotation.uuid = channel.quotationUuid
        const jobModel = new FbaQuotation(this.fbaQuotation)
        await jobModel.loadFbaQuotationRelated({
          quotation: true,
          label: true,
          partitionSetting: true,
          setupSetting: true,
          charge: true,
          customerPrice: true
        })
      } else {
        this.fbaChannel = null
        this.fbaQuotation = null
        this.form.fbaChannel = this.fbaChannel
        this.form.fbaQuotation = this.fbaQuotation
      }
    },
    bubbleCountingChange() {
      if (this.form.serviceChannel) {
        this.$alert(StrUtils.substitute(this.$t('FbaJob.channelInfoCannotChange'), this.$t('FbaJob.BubbleCountingRatio')), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          type: 'warning'
        })
        this.form.bubbleCountingRatio = this.bubbleCountingRatio
      } else {
        if (this.form.bubbleCountingRatio > 9999) {
          this.form.bubbleCountingRatio = 9999
          this.bubbleCountingRatio = 9999
        } else {
          this.bubbleCountingRatio = this.form.bubbleCountingRatio
        }
        if (this.form.goods && this.form.goods.length > 0) {
          this.calcSingleVolumetricWeightAndChargeWeight(this.form.goods)
          this.calcContractTotal()
          this.genSummaryGoodsDetailList()
        } else {
          const refreshCharge = this.calcVolumetricAndChargeWeight()
          if (refreshCharge) {
            this.changeChargeWeight()
          }
        }
      }
    },
    bubbleSplittingRatioChange() {
      if (this.form.serviceChannel) {
        this.$alert(StrUtils.substitute(this.$t('FbaJob.channelInfoCannotChange'), this.$t('FbaJob.BubbleSplittingRatio')), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          type: 'warning'
        })
        this.form.bubbleSplittingRatio = this.bubbleSplittingRatio
      } else {
        if (this.form.bubbleSplittingRatio > 100) {
          this.form.bubbleSplittingRatio = 100
          this.bubbleSplittingRatio = 100
        } else {
          this.bubbleSplittingRatio = this.form.bubbleSplittingRatio
        }
      }
    },
    calcContractTotal(init = false) {
      this.form.quantityContract = 0.0
      this.form.weightContract = 0.0
      this.form.cubageContract = 0.0
      this.form.volumetricWeightContract = 0.0
      this.form.chargeWeightContract = 0.0
      let electric = false
      let magnetic = false
      let powdery = false
      let liquid = false
      if (init) {
        this.form.quantityContract = Number(this.quantityContract)
        this.form.weightContract = Number(this.weightContract).toFixed(2)
        this.form.cubageContract = Number(this.cubageContract).toFixed(3)
        this.form.volumetricWeightContract = Number(this.volumetricWeightContract).toFixed(3)
        this.form.chargeWeightContract = Number(this.chargeWeightContract).toFixed(3)
      } else {
        let cubage = 0
        if (this.form.goods && this.form.goods.length > 0) {
          for (const item of this.form.goods) {
            if (item.boxesNumber) {
              this.form.quantityContract += Number(item.boxesNumber)
            }
            if (item.weight) {
              this.form.weightContract += Number(item.weight)
            }
            if (item.boxLength && item.boxWidth && item.boxHeight) {
              const tempCubage = Number(item.boxLength) * Number(item.boxWidth) * Number(item.boxHeight) * Number(item.boxesNumber)
              cubage += tempCubage
            }
            if (!electric && item.electric) {
              electric = true
            }
            if (!magnetic && item.magnetic) {
              magnetic = true
            }
            if (!powdery && item.powdery) {
              powdery = true
            }
            if (!liquid && item.liquid) {
              liquid = true
            }
          }
        }
        this.form.electric = electric
        this.form.magnetic = magnetic
        this.form.powdery = powdery
        this.form.liquid = liquid
        this.form.cubageContract = (cubage / 1000000).toFixed(3)
        // 材积
        if (this.bubbleCountingRatio > 0) {
          if (Number(this.form.chargingMethod) === 0) {
            this.form.volumetricWeightContract = (cubage / Number(this.bubbleCountingRatio)).toFixed(3)
          } else {
            this.form.volumetricWeightContract = (this.form.weightContract / 1000).toFixed(3)
          }
        }
        // 计费重量
        const params = {
          goods: this.form.goods,
          fbaQuotation: this.fbaQuotation,
          chargingMethod: this.form.chargingMethod,
          quantity: this.form.quantityContract,
          weight: this.form.weightContract,
          cubage: this.form.cubageContract,
          volumetricWeight: this.form.volumetricWeightContract
        }
        const chargeWeight = FbaQuotationUtil.calChargeWeight(params)
        const refreshCharge = Number(Number(chargeWeight).toFixed(3)) !== Number(this.chargeWeightContract)
        this.form.chargeWeightContract = Number(chargeWeight).toFixed(3)
        this.form.weightContract = this.form.weightContract.toFixed(2)
        this.quantityContract = this.form.quantityContract
        this.weightContract = this.form.weightContract
        this.cubageContract = this.form.cubageContract
        this.volumetricWeightContract = this.form.volumetricWeightContract
        this.chargeWeightContract = this.form.chargeWeightContract
        if (refreshCharge) {
          this.changeChargeWeight()
        }
      }
    },
    // 计算材积和计费重量
    calcVolumetricAndChargeWeight(volumetricWeight) {
      const cubage = this.form.cubageContract * 1000000
      // 材积
      if (volumetricWeight && volumetricWeight > 0) {
        this.form.volumetricWeightContract = volumetricWeight
      } else {
        if (this.bubbleCountingRatio > 0) {
          if (Number(this.form.chargingMethod) === 0) {
            this.form.volumetricWeightContract = (cubage / Number(this.bubbleCountingRatio)).toFixed(3)
          } else {
            this.form.volumetricWeightContract = (this.form.weightContract / 1000).toFixed(3)
          }
        }
      }
      // 计费重量
      const params = {
        goods: this.form.goods,
        fbaQuotation: this.fbaQuotation,
        chargingMethod: this.form.chargingMethod,
        quantity: this.form.quantityContract,
        weight: this.form.weightContract,
        cubage: this.form.cubageContract,
        volumetricWeight: this.form.volumetricWeightContract
      }
      const chargeWeight = FbaQuotationUtil.calChargeWeight(params)
      const refreshCharge = Number(chargeWeight) !== Number(this.chargeWeightContract)
      if (this.form.quantityContract > 0 && this.form.weightContract > 0 && this.form.cubageContract > 0 && this.form.volumetricWeightContract > 0) {
        this.form.chargeWeightContract = Number(chargeWeight).toFixed(3)
      }
      this.volumetricWeightContract = Number(this.form.volumetricWeightContract).toFixed(3)
      this.chargeWeightContract = Number(this.form.chargeWeightContract).toFixed(3)
      return refreshCharge
    },
    // 计算货物单箱材积和计费重量
    calcSingleVolumetricWeightAndChargeWeight(goods) {
      for (const item of goods) {
        let volumetricWeight = 0.0
        let chargeWeight = 0.0
        // 材积
        if (this.bubbleCountingRatio > 0) {
          if (Number(this.form.chargingMethod) === 0) {
            volumetricWeight = ((Number(item.boxLength) * Number(item.boxWidth) * Number(item.boxHeight) * Number(item.boxesNumber)) / Number(this.bubbleCountingRatio)).toFixed(3)
          } else {
            volumetricWeight = (item.singleBoxWeight / 1000).toFixed(3)
          }
        }
        // 计费重量
        const info = {
          goods: item,
          fbaChannel: this.fbaChannel,
          chargingMethod: this.form.chargingMethod,
          fbaQuotation: this.fbaQuotation,
          volumetricWeight: volumetricWeight,
          warehouseCode: this.form.warehouseCode
        }
        chargeWeight = FbaQuotationUtil.calSingleChargeWeight(info)
        item.volumetricWeight = volumetricWeight
        item.chargeWeight = chargeWeight
      }
      this.detailList.goodGridOptions.api.refreshCells({ force: true })
    },
    async changeQuantity() {
      const goodsList = this.form.goods || []
      if (goodsList && goodsList.length > 0) {
        await this.$alert(this.$t('Warehouse.editActJmt'), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          type: 'warning',
          callback: () => {
            this.quantityContract = this.form.quantityContract
          }
        })
      } else {
        this.form.quantityContract = Number(this.quantityContract)
        const refreshCharge = this.calcVolumetricAndChargeWeight()
        if (refreshCharge) {
          await this.changeChargeWeight()
        }
      }
    },
    async changeWeight() {
      const goodsList = this.form.goods || []
      if (goodsList && goodsList.length > 0) {
        await this.$alert(this.$t('Warehouse.editActJmt'), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          type: 'warning',
          callback: () => {
            this.weightContract = this.form.weightContract
          }
        })
      } else {
        this.weightContract = Number(this.weightContract).toFixed(2)
        this.form.weightContract = this.weightContract
        const refreshCharge = this.calcVolumetricAndChargeWeight()
        if (refreshCharge) {
          await this.changeChargeWeight()
        }
      }
    },
    async changeCubage() {
      const goodsList = this.form.goods || []
      if (goodsList && goodsList.length > 0) {
        await this.$alert(this.$t('Warehouse.editActJmt'), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          type: 'warning',
          callback: () => {
            this.cubageContract = this.form.cubageContract
          }
        })
      } else {
        this.cubageContract = Number(this.cubageContract).toFixed(3)
        this.form.cubageContract = this.cubageContract
        const refreshCharge = this.calcVolumetricAndChargeWeight()
        if (refreshCharge) {
          this.changeChargeWeight()
        }
      }
    },
    async changeVolumetricWeight() {
      const goodsList = this.form.goods || []
      if (goodsList && goodsList.length > 0) {
        await this.$alert(this.$t('Warehouse.editActJmt'), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          type: 'warning',
          callback: () => {
            this.volumetricWeightContract = this.form.volumetricWeightContract
          }
        })
      } else {
        this.volumetricWeightContract = Number(this.volumetricWeightContract).toFixed(3)
        const refreshCharge = this.calcVolumetricAndChargeWeight(this.volumetricWeightContract)
        if (refreshCharge) {
          await this.changeChargeWeight()
        }
      }
    },
    async changeChargeWeight() {
      this.chargeWeightContract = Number(this.chargeWeightContract).toFixed(3)
      this.form.chargeWeightContract = this.chargeWeightContract
      if (this.form.customerId && this.form.serviceChannel && this.chargeWeightContract && this.chargeWeightContract > 0) {
        await this.$confirm(this.$t('FbaJob.changeChargeWeight'), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          cancelButtonText: this.$t('CargoMsg.Cargo_No'),
          type: 'warning'
        }).then(() => {
          // 刷新费用
          this.refreshCharge()
        }).catch(() => {
        })
      }
    },
    // 批量维护
    batchAddHandler() {
      this.batchMaintenanceDialog.visible = true
    },
    // 移除货物
    delDetailHandler() {
      this.$confirm(this.$t('Message.DeleteTheSelectedRecord'), this.$t('Message.Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        const uuids = []
        const tmpUuids = []
        getGridSelected(this.detailList.goodGridOptions).forEach(rowData => {
          if (this.goodsViewSummary) {
            this.summaryAndDetailGoodsRel[rowData.key].forEach(detailGoods => {
              detailGoods.uuid ? uuids.push(detailGoods.uuid) : tmpUuids.push(detailGoods.tmpUuid)
            })
            const index = this.summaryGoodsDetailList.findIndex(item => item.key === rowData.key)
            if (index > -1) {
              this.summaryGoodsDetailList.splice(index, 1)
            }
          } else {
            rowData.uuid ? uuids.push(rowData.uuid) : tmpUuids.push(rowData.tmpUuid)
          }
        })
        this.deleteGoodsDetail(uuids)
        this.deleteTmpGoodsDetail(tmpUuids)
        this.calcContractTotal()
      }).catch(() => {
        return Promise.reject(this.$t('Message.DeletionCancelled'))
      })
    },
    // 删除已入库明细箱货信息
    deleteGoodsDetail(uuids) {
      for (const uuid of uuids) {
        if (uuid && !this.delWarehouseInDetailKeys.includes(uuid)) {
          this.delWarehouseInDetailKeys.push(uuid)
        }
        const index = this.form.goods.findIndex(item => item.uuid === uuid)
        if (index > -1) {
          this.form.goods.splice(index, 1)
        }
      }
      this.genSummaryGoodsDetailList()
    },
    // 删除临时明细箱货信息
    deleteTmpGoodsDetail(uuids) {
      for (const uuid of uuids) {
        const index = this.form.goods.findIndex(item => item.tmpUuid === uuid)
        if (index > -1) {
          this.form.goods.splice(index, 1)
        }
      }
      this.genSummaryGoodsDetailList()
    },
    // 清空
    delAllHandler() {
      this.$confirm(this.$t('Warehouse.deleteTheDetailRecord'), this.$t('Message.Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
        cancelButtonText: this.$t('CargoMsg.Cargo_No'),
        type: 'warning'
      }).then(() => {
        // 清空明细数据
        if (this.form.goods && this.form.goods.length > 0) {
          this.form.goods.forEach(item => {
            this.delWarehouseInDetailKeys.push(item.uuid)
          })
          this.form.goods = []
        }
        // 清空汇总数据
        this.summaryGoodsDetailList = []
        this.form.quantityContract = 0
        this.form.weightContract = 0.0
        this.form.cubageContract = 0.0
        this.form.volumetricWeightContract = 0.0
        this.form.chargeWeightContract = 0.0
        this.quantityContract = 0
        this.weightContract = Number(0).toFixed(2)
        this.cubageContract = Number(0).toFixed(3)
        this.volumetricWeightContract = Number(0).toFixed(3)
        this.chargeWeightContract = Number(0).toFixed(3)
      }).catch(() => {
        return Promise.reject(this.$t('Message.DeletionCancelled'))
      })
    },
    // 批量导入：货物信息导入、下载模版
    exportOrderHandle() {
      switch (this.exportOrderCommand) {
        case this.$t('SeaExport.GoodsInformationImport'):
          this.$refs.uploadOrder.submit()
          break
        case this.$t('CargoMsg.Cargo_DownloadTemplate'):
          this.downloadTemplate()
          break
      }
    },
    beforeOrderUpload(file) {
      this.loading = getLoading()
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.loading.close()
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    uploadOrderSuccess(res, file, fileList) {
      const { data } = res
      this.loading.close()
      this.$confirm(data.message, this.$t('queryJob.uploadSucceeded'), {
        cancelButtonText: this.$t('Partners.downloadImportResults'),
        confirmButtonText: this.$t('Message.Confirm'),
        distinguishCancelAndClose: true,
        beforeClose: async(action, instance, done) => {
          if (action === 'cancel') {
            await cache.load(cacheName.USER, cacheName.CONFIG)
            const storageUrl = cache.config.get('StorageURL')
            const url = `${URL.common.findByFileId}/${data.data}?sessionId=${this.$store.getters.token}`
            const el = document.createElement('a')
            document.body.appendChild(el)
            el.href = url
            el.target = '_blank'
            el.click()
            document.body.removeChild(el)
          } else {
            done()
          }
        }
      })
      this.$emit('onRefresh')
    },
    handleError(error) {
      const errorData = JSON.parse(error.message)
      this.$message.error({ 'message': errorData.message, 'duration': 15000 })
      this.loading.close()
    },
    // 选择收发通
    codeSearchCallback(data) {
      if (data.shipperInfo) {
        this.copyShipper(data.shipperInfo)
      }
      if (data.consigneeInfo) {
        this.copyConsignee(data.consigneeInfo)
      }
      if (data.notifyInfo) {
        this.copyNotify(data.notifyInfo)
      }
    },
    // 发货人
    copyShipper(data) {
      console.log('copyShipper', data)
      console.log('this.form', this.form)
      this.form.address.shipperEnterpriseName = data.shipperEnterpriseName
      this.form.address.shipperCountryCode = data.shipperCountryCode
      this.form.address.shipperCountryName = data.shipperCountryName
      this.form.address.shipperProvinceCode = data.shipperProvinceCode
      this.form.address.shipperProvinceName = data.shipperProvinceName
      this.form.address.shipperCityCode = data.shipperCityCode
      this.form.address.shipperCityName = data.shipperCityName
      this.form.address.shipperZipCode = data.shipperZipCode
      this.form.address.shipperFax = data.shipperFax
      this.form.address.shipperContactName = data.shipperContactName
      this.form.address.shipperContactTel = data.shipperContactTel
      this.form.address.shipperContactEmail = data.shipperContactEmail
      this.form.address.shipperAddress1 = data.shipperAddress1
      this.form.address.shipperAddress2 = data.shipperAddress2
      this.form.address.shipperAddress3 = data.shipperAddress3
      this.form.address.shipperEoriNo = data.shipperEoriNo
      this.form.address.shipperVatNo = data.shipperVatNo
      this.form.address.shipperVatNoType = data.shipperVatNoType
    },
    // 收货人
    copyConsignee(data) {
      console.log('copyConsignee', data)
      this.form.address.consigneeEnterpriseName = data.consigneeEnterpriseName
      this.form.address.consigneeCountryCode = data.consigneeCountryCode
      this.form.address.consigneeCountryName = data.consigneeCountryName
      this.form.address.consigneeProvinceCode = data.consigneeProvinceCode
      this.form.address.consigneeProvinceName = data.consigneeProvinceName
      this.form.address.consigneeCityCode = data.consigneeCityCode
      this.form.address.consigneeCityName = data.consigneeCityName
      this.form.address.consigneeZipCode = data.consigneeZipCode
      this.form.address.consigneeFax = data.consigneeFax
      this.form.address.consigneeContactName = data.consigneeContactName
      this.form.address.consigneeContactTel = data.consigneeContactTel
      this.form.address.consigneeContactEmail = data.consigneeContactEmail
      this.form.address.consigneeAddress1 = data.consigneeAddress1
      this.form.address.consigneeAddress2 = data.consigneeAddress2
      this.form.address.consigneeAddress3 = data.consigneeAddress3
      this.form.address.consigneeEoriNo = data.consigneeEoriNo
      this.form.address.consigneeVatNo = data.consigneeVatNo
      this.form.address.consigneeVatNoType = data.consigneeVatNoType
    },
    // 通知人
    copyNotify(data) {
      console.log('copyNotify', data)
      this.form.address.notifyEnterpriseName = data.notifyEnterpriseName
      this.form.address.notifyCountryCode = data.notifyCountryCode
      this.form.address.notifyCountryName = data.notifyCountryName
      this.form.address.notifyProvinceCode = data.notifyProvinceCode
      this.form.address.notifyProvinceName = data.notifyProvinceName
      this.form.address.notifyCityCode = data.notifyCityCode
      this.form.address.notifyCityName = data.notifyCityName
      this.form.address.notifyZipCode = data.notifyZipCode
      this.form.address.notifyFax = data.notifyFax
      this.form.address.notifyContactName = data.notifyContactName
      this.form.address.notifyContactTel = data.notifyContactTel
      this.form.address.notifyContactEmail = data.notifyContactEmail
      this.form.address.notifyAddress1 = data.notifyAddress1
      this.form.address.notifyAddress2 = data.notifyAddress2
      this.form.address.notifyAddress3 = data.notifyAddress3
      this.form.address.notifyEoriNo = data.notifyEoriNo
      this.form.address.notifyVatNo = data.notifyVatNo
      this.form.address.notifyVatNoType = data.notifyVatNoType
    },
    // 列编辑
    async onCellChange(params) {
      const field = params.colDef.field
      const goods = params.data
      const internal = this.detailList.goodGridOptions.api.getSelectedRows()
      let volumetricWeight = 0.0
      let chargeWeight = 0.0
      if (field === 'singleBoxWeight' || field === 'boxLength' || field === 'boxWidth' || field === 'boxHeight') {
        // 材积
        if (this.bubbleCountingRatio > 0) {
          if (Number(this.form.chargingMethod) === 0) {
            volumetricWeight = ((Number(goods.boxLength) * Number(goods.boxWidth) * Number(goods.boxHeight) * Number(goods.boxesNumber)) / Number(this.bubbleCountingRatio)).toFixed(3)
          } else {
            volumetricWeight = (goods.singleBoxWeight / 1000).toFixed(3)
          }
        }
        // 计费重量
        const info = {
          goods: goods,
          fbaChannel: this.fbaChannel,
          chargingMethod: this.form.chargingMethod,
          fbaQuotation: this.fbaQuotation,
          volumetricWeight: volumetricWeight,
          warehouseCode: this.form.warehouseCode
        }
        chargeWeight = FbaQuotationUtil.calSingleChargeWeight(info)
      }
      if (this.goodsViewSummary) {
        // 编辑汇总数据 同步至本条汇总数据的所有明细数据
        const detailsOfSummaryGoods = this.summaryAndDetailGoodsRel[goods.key]
        detailsOfSummaryGoods.forEach(e => {
          if (field !== 'shipmentId' || !e.containerNo) {
            e[field] = goods[field]
          }
          if (field === 'singleBoxWeight') {
            e.weight = e.singleBoxWeight * e.boxesNumber
          }
          if (field === 'singleBoxWeight' || field === 'boxLength' || field === 'boxWidth' || field === 'boxHeight') {
            e.volumetricWeight = volumetricWeight
            e.chargeWeight = chargeWeight
          }
          e.updated = true
        })
        if (field === 'singleBoxWeight') {
          goods.weight = goods.singleBoxWeight * goods.boxesNumber
          this.detailList.goodGridOptions.api.updateRowData({ update: internal })
        }
        if (field === 'singleBoxWeight' || field === 'boxLength' || field === 'boxWidth' || field === 'boxHeight') {
          goods.volumetricWeight = volumetricWeight
          goods.chargeWeight = chargeWeight
          this.detailList.goodGridOptions.api.updateRowData({ update: internal })
        }
        if (field === 'shipmentId') {
          const containerNo = goods.containerNo
          if (containerNo) {
            await this.$confirm(this.$t('Warehouse.editShipmentId'), this.$t('Message.Tips'), {
              confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
              cancelButtonText: this.$t('CargoMsg.Cargo_No'),
              type: 'warning'
            }).then(() => {
              // 校验containerNo是否重复
              for (const detailGoods of detailsOfSummaryGoods) {
                const detailContainerNo = detailGoods.containerNo
                if (detailContainerNo) {
                  const newDetailContainerNo = detailContainerNo.replace(new RegExp(params.oldValue), goods.shipmentId)
                  if (this.containerNoDuplicate(newDetailContainerNo)) {
                    goods.shipmentId = params.oldValue
                    this.detailList.goodGridOptions.api.updateRowData({ update: internal })
                    return
                  }
                }
              }
              for (const detailGoods of detailsOfSummaryGoods) {
                const detailContainerNo = detailGoods.containerNo
                if (detailContainerNo) {
                  const newDetailContainerNo = detailContainerNo.replace(new RegExp(params.oldValue), goods.shipmentId)
                  detailGoods.shipmentId = goods.shipmentId
                  detailGoods.containerNo = newDetailContainerNo
                }
              }
              goods.containerNo = containerNo.replace(new RegExp(params.oldValue), goods.shipmentId)
              this.detailList.goodGridOptions.api.updateRowData({ update: internal })
            }).catch(() => {
              goods.shipmentId = params.oldValue
              this.detailList.goodGridOptions.api.updateRowData({ update: internal })
              return Promise.reject(this.$t('Message.EditCancelled'))
            })
          }
        }
      } else {
        // 编辑单货箱重量同步重量
        if (field === 'singleBoxWeight') {
          goods.weight = goods.singleBoxWeight * goods.boxesNumber
          this.detailList.goodGridOptions.api.updateRowData({ update: internal })
        }
        // 编辑shipmentId刷新货箱编号
        if (field === 'shipmentId') {
          const containerNo = goods.containerNo
          if (containerNo) {
            await this.$confirm(this.$t('Warehouse.editShipmentId'), this.$t('Message.Tips'), {
              confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
              cancelButtonText: this.$t('CargoMsg.Cargo_No'),
              type: 'warning'
            }).then(() => {
              const newContainerNo = containerNo.replace(new RegExp(params.oldValue), goods.shipmentId)
              // 校验containerNo是否重复
              if (this.containerNoDuplicate(newContainerNo)) {
                goods.shipmentId = params.oldValue
                this.detailList.goodGridOptions.api.updateRowData({ update: internal })
                return
              }
              goods.containerNo = newContainerNo
              this.detailList.goodGridOptions.api.updateRowData({ update: internal })
            }).catch(() => {
              goods.shipmentId = params.oldValue
              this.detailList.goodGridOptions.api.updateRowData({ update: internal })
              return Promise.reject(this.$t('Message.EditCancelled'))
            })
          }
        }
        if (field === 'singleBoxWeight' || field === 'boxLength' || field === 'boxWidth' || field === 'boxHeight') {
          goods.volumetricWeight = volumetricWeight
          goods.chargeWeight = chargeWeight
          this.detailList.goodGridOptions.api.updateRowData({ update: internal })
        }
        goods.updated = true
        this.genSummaryGoodsDetailList()
      }
      this.calcContractTotal()
    },
    // 验证containerNo是否重复
    containerNoDuplicate(containerNo) {
      for (const detail of this.form.goods) {
        if (containerNo === detail.containerNo) {
          this.$message.warning(StrUtils.substitute(this.$t('Warehouse.duplicateContainerNo'), containerNo))
          return true
        }
      }
      return false
    },
    onSummaryContainerNoCellFocused(event) {
      if (event.column && event.column.colId === 'containerNo') {
        const data = this.detailList.goodGridOptions.api.getDisplayedRowAtIndex(event.rowIndex).data
        if (data !== null && this.isEditing) {
          if (!this.allowContainerNoCellEdit(data)) {
            return
          }
          this.containerNoEditor.shipmentId = data.shipmentId
          this.containerNoEditor.boxesNumber = data.boxesNumber
          this.containerNoEditor.visible = true
          this.containerNoEditor.key = data.key
          this.containerNoEditor.containerNo = data.containerNo
        }
      }
    },
    onDetailContainerNoCellFocused(event) {
      if (event.column && event.column.colId === 'containerNo') {
        const data = this.detailList.goodGridOptions.api.getDisplayedRowAtIndex(event.rowIndex).data
        if (data !== null && this.isEditing) {
          if (!this.allowContainerNoCellEdit(data)) {
            return
          }
          this.containerNoEditor.shipmentId = data.shipmentId
          this.containerNoEditor.visible = true
          this.containerNoEditor.key = data.uuid ? data.uuid : data.tmpUuid
          this.containerNoEditor.containerNo = data.containerNo
        }
      }
    },
    allowContainerNoCellEdit(data) {
      if (!data.shipmentId) {
        this.$message.warning(this.$t('Warehouse.shipmentIdNotNull'))
        return false
      }
      return true
    },
    // 生成汇总数据
    genSummaryGoodsDetailList() {
      const sameGoods = {}
      const result = []
      const keys = []
      const sourceData = this.form.goods || []
      for (const item of sourceData) {
        const obj = {
          boxSeqLen: item.containerNo.substring(item.shipmentId.length).length,
          shipmentId: item.shipmentId,
          referenceId: item.referenceId,
          singleBoxWeight: item.singleBoxWeight,
          boxLength: item.boxLength,
          boxWidth: item.boxWidth,
          boxHeight: item.boxHeight,
          cargoEnglishName: item.cargoEnglishName,
          cargoChineseName: item.cargoChineseName
        }
        const key = JSON.stringify(obj)
        const currentSeq = Number(item.containerNo.substring(item.shipmentId.length))
        // 没有匹配到key则为新的一条汇总数据
        if (!sameGoods[key]) {
          keys.push(key)
          sameGoods[key] = { key: key, beginSeq: currentSeq, endSeq: currentSeq, ...item }
          sameGoods[key].boxesNumber = Number(item.boxesNumber)
          sameGoods[key].weight = Number(item.weight)
          // 把当前明细数据与汇总数据通过key建立关联关系，方便后续对汇总数据的操作同步至明细
          this.summaryAndDetailGoodsRel[key] = []
          this.summaryAndDetailGoodsRel[key].push(item)
          continue
        }
        const goods = sameGoods[key]
        // 计算汇总箱数和重量
        goods.boxesNumber += Number(item.boxesNumber)
        goods.weight += Number(item.weight)
        this.summaryAndDetailGoodsRel[key].push(item)
        // 当前明细已存在汇总数据则比较并设置箱货编号起始和结束序号
        if (currentSeq < goods.beginSeq) {
          // 如果当前明细箱货编号作为起始编号则同时设置containerNo 方便最后生成汇总数据的箱货编号
          goods.beginSeq = currentSeq
          goods.containerNo = item.containerNo
        }
        if (currentSeq > goods.endSeq) {
          goods.endSeq = currentSeq
        }
      }
      // 生成汇总数据的箱货编号
      keys.forEach(key => {
        const goods = sameGoods[key]
        if (goods.beginSeq !== goods.endSeq && !isNaN(goods.beginSeq) && !isNaN(goods.endSeq)) {
          goods.containerNo = goods.containerNo + '-' + goods.endSeq
        }
        result.push(goods)
      })
      this.summaryGoodsDetailList = result
    },
    checkSubmitData() {
      // 中邮定制字段 保存校验
      if (this.isZY && !this.form.saleProductCode) {
        throw new TabError(this.$t('Message.SaleProductCodeCannotBeNull'), 'tabBaseInfo')
      }
      if (this.isZY && !this.form.fullOrInside) {
        throw new TabError(this.$t('Message.FullOrInsideCannotBeNull'), 'tabBaseInfo')
      }
      // FBA 基础信息字段必填校验
      if (!this.form.customerId) {
        throw new TabError(this.$t('Message.ConsignationCompanyCannotBeNull'), 'tabBaseInfo')
      }
      if (!this.form.sales) {
        throw new TabError(this.$t('Message.SalesCannotBeNull'), 'tabBaseInfo')
      }
      if (!this.form.salesOffice) {
        throw new TabError(this.$t('Message.SalesBranchCompanyIsNullPleaseReSelectSales'), 'tabBaseInfo')
      }
      if (!this.form.salesDepartment) {
        throw new TabError(this.$t('Message.SalesDepartmentIsNullPleaseReSelectSales'), 'tabBaseInfo')
      }
      if ((this.form.shippingType === 'SE' || this.form.shippingType === 'RE') && !this.form.containerLoadType) {
        throw new TabError('整拼类型不能为空！', 'tabBaseInfo')
      }
      if (this.form.shippingType === 'AE' && typeof this.form.operateType !== 'number') {
        throw new TabError('操作模式不能为空！', 'tabBaseInfo')
      }
      // if (!this.form.domesticWarehouse) {
      //   throw new TabError('收货仓库不能为空！', 'tabBaseInfo')
      // }
      if (!this.form.preWarehousingTime) {
        throw new TabError('预计入仓/货好时间不能为空！', 'tabBaseInfo')
      }
      if (!this.form.warehouseCode) {
        throw new TabError('目的地不能为空！', 'tabBaseInfo')
      }
      if (!this.form.country) {
        throw new TabError('目的国不能为空！', 'tabBaseInfo')
      }
      if (!this.form.zipCode) {
        throw new TabError('邮编不能为空！', 'tabBaseInfo')
      }
      if (!this.form.shippingType) {
        throw new TabError('运输方式不能为空！', 'tabBaseInfo')
      }
      // if (!this.form.destinationDistribution && Number(this.form.destinationDistribution) !== 0) {
      //   throw new TabError('目的地配送方式不能为空！', 'tabBaseInfo')
      // }
      // if (!this.form.incoTerm) {
      //   throw new TabError('贸易条款不能为空！', 'tabBaseInfo')
      // }
      if (!this.form.chargingMethod && this.form.chargingMethod !== 0) {
        throw new TabError(this.$t('FbaJob.ChargingMethod') + '不能为空！', 'tabBaseInfo')
      }
      if (!this.form.cargoType) {
        throw new TabError('货物类型不能为空！', 'tabBaseInfo')
      }

      // 上门提货为是时,校验必填
      if (this.form.pickupService) {
        if (!this.form.doorMan) {
          throw new TabError('联系人不能为空！', 'tabBaseInfo')
        }
        if (!this.form.pickupTime) {
          throw new TabError('提货时间不能为空！', 'tabBaseInfo')
        }
        if (!this.form.pickupDoor) {
          throw new TabError('提货门点不能为空！', 'tabBaseInfo')
        }
        if (!this.form.doorManTel) {
          throw new TabError('联系电话不能为空！', 'tabBaseInfo')
        }
        if (!this.form.doorAddress) {
          throw new TabError('门点地址不能为空！', 'tabBaseInfo')
        }
      }

      // 箱货明细字段校验
      if (this.form.goods && this.form.goods.length > 0) {
        for (const detail of this.form.goods) {
          if (!detail.containerNo) {
            throw new TabError(this.$t('Warehouse.saveCheckContainerNoFail'), 'tabBaseInfo')
          }
          if (!detail.shipmentId) {
            throw new TabError(this.$t('Warehouse.saveCheckShipmentIdFail'), 'tabBaseInfo')
          }
          if (!detail.singleBoxWeight) {
            throw new TabError(this.$t('Warehouse.saveCheckQuantityFail'), 'tabBaseInfo')
          }
          if (!detail.boxLength) {
            throw new TabError(this.$t('Warehouse.saveCheckBoxLengthFail'), 'tabBaseInfo')
          }
          if (!detail.boxWidth) {
            throw new TabError(this.$t('Warehouse.saveCheckBoxWidthFail'), 'tabBaseInfo')
          }
          if (!detail.boxHeight) {
            throw new TabError(this.$t('Warehouse.saveCheckBoxHeightFail'), 'tabBaseInfo')
          }
          if (!detail.cargoChineseName) {
            throw new TabError(this.$t('Warehouse.saveCheckChineseCargoNameFail'), 'tabBaseInfo')
          }
          if (!detail.cargoEnglishName) {
            throw new TabError(this.$t('Warehouse.saveCheckEnglishCargoNameFail'), 'tabBaseInfo')
          }
        }
      }
    },
    // 组装打印参数
    getPrintData() {
      const params = {}
      params.JOB_UUID = this.form.uuid
      params.category = 'BOOKING'
      params.ctx = new FbaJob(this.form)
      return params
    },
    // 计费方式随运输方式改变
    changeShippingType() {
      if (this.form.serviceChannel) {
        this.$alert(StrUtils.substitute(this.$t('FbaJob.channelInfoCannotChange'), this.$t('FbaJob.ShippingType')), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          type: 'warning'
        })
        this.form.shippingType = this.shippingType
      } else {
        this.form.lob = this.form.shippingType
        this.shippingType = this.form.shippingType
        if (this.form.shippingType === 'SE' || this.form.shippingType === 'RE') {
          this.form.chargingMethod = '1'
        } else if (this.form.shippingType === 'AE') {
          this.form.chargingMethod = '0'
        }
        this.getCargoType()
        this.initAddedService()
        this.loadCompanyUser()
      }
    },
    // 目的地配送方式改变
    destinationDistributionChange() {
      if (this.form.serviceChannel) {
        this.$alert(StrUtils.substitute(this.$t('FbaJob.channelInfoCannotChange'), this.$t('FbaJob.DestinationDistribution')), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          type: 'warning'
        })
        this.form.destinationDistribution = this.destinationDistribution
      } else {
        this.destinationDistribution = this.form.destinationDistribution
        this.syncConsigneeInfo()
      }
    },
    // 改变计费方式
    chargingMethodChange() {
      if (this.form.serviceChannel) {
        this.$alert(StrUtils.substitute(this.$t('FbaJob.channelInfoCannotChange'), this.$t('FbaJob.ChargingMethod')), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          type: 'warning'
        })
        this.form.chargingMethod = this.chargingMethod
      } else {
        this.chargingMethod = this.form.chargingMethod
        if (this.form.goods && this.form.goods.length > 0) {
          this.calcSingleVolumetricWeightAndChargeWeight(this.form.goods)
          this.calcContractTotal()
          this.genSummaryGoodsDetailList()
        } else {
          this.calcVolumetricAndChargeWeight()
        }
      }
    },
    // 客户属性过滤
    customerIdFilter(item, inputVal) {
      if (item.cmpIdx === inputVal) {
        return true
      }
      return item.customer && item.fba && item.active
    },
    // 货物类型
    cargoTypeFilter(item, inputVal) {
      if (item.code === inputVal) {
        return true
      }
      return item.fbaSea || item.fbaAir || item.fbaRailway
    },
    // 保存为常用发货人
    saveBillAddressDialog(type) {
      if (!this.form.customerId) {
        this.$message.warning('请先维护委托单位.')
        return
      }
      if (!this.form.warehouseCode) {
        this.$message.warning('请先维护目的地.')
        return
      }
      const address = this.form.address
      let name = ''
      if (type === 'shipper') {
        name = '发货人'
        if (!address.shipperEnterpriseName || !address.shipperEnterpriseName.trim()) {
          this.$message.warning('请先维护发货人公司名称.')
          return
        }
      } else if (type === 'consignee') {
        name = '收货人'
        if (!address.consigneeEnterpriseName || !address.consigneeEnterpriseName.trim()) {
          this.$message.warning('请先维护收货人公司名称.')
          return
        }
      } else if (type === 'notify') {
        name = '通知人'
        if (!address.notifyEnterpriseName || !address.notifyEnterpriseName.trim()) {
          this.$message.warning('请先维护通知人公司名称.')
          return
        }
      }
      // 公共属性
      address.officeId = this.$store.getters.currentOfficeId
      address.partnerId = this.form.customerId
      address.warehouseCode = this.form.warehouseCode
      address.type = type

      const loading = getLoading4Cxt(this)
      saveBillAddress(address).then(res => {
        const result = res.data
        if (!result) {
          this.$message.warning('保存失败.')
          return
        }
        if (result === 1) { // 成功
          this.$message.success('保存成功.')
        } else if (result === 2) { // 重复
          this.$message.success('已保存' + name + '信息.')
        }
      }).finally(() => {
        loading.close()
      })
    },
    // 选择常用通知人
    fbaCodeSearchBtn() {
      if (!this.form || !this.form.customerId || Number(this.form.customerId) <= 0) {
        this.$message.warning('请先选择委托单位。')
        return
      }
      this.billAddressDialog.visible = true
    },
    // 同步收货人信息
    syncConsigneeInfo() {
      if (!this.form.warehouseCode || (!this.form.destinationDistribution && Number(this.form.destinationDistribution) !== 0)) return
      const overseaWarehouse = getObjectByCache(TYPE_NAMES.basic_data_OverseaWarehouse, 'warehouseCode', this.form.warehouseCode)
      if (!overseaWarehouse) return
      // 非客户自提 则需要 同步到 收货人信息中
      if (Number(this.form.destinationDistribution) === 3) {
        const address = this.form.address
        if (address.consigneeEnterpriseName === 'Amazon' || address.consigneeEnterpriseName === overseaWarehouse.countryEnglishName) address.consigneeEnterpriseName = ''
        if (address.consigneeAddress1 === overseaWarehouse.address1) address.consigneeAddress1 = ''
        if (address.consigneeAddress2 === overseaWarehouse.address2) address.consigneeAddress2 = ''
        if (address.consigneeAddress3 === overseaWarehouse.address3) address.consigneeAddress3 = ''
        return
      }
      this.form.address.consigneeEnterpriseName = overseaWarehouse.ifFba ? 'Amazon' : overseaWarehouse.countryEnglishName
      const address = this.form.address
      // 邮编、国家、省/州、城市、详细地址信息
      address.consigneeZipCode = overseaWarehouse.zipCode
      address.consigneeCountryCode = overseaWarehouse.countryCode
      address.consigneeCountryName = overseaWarehouse.countryChineseName
      address.consigneeProvinceCode = overseaWarehouse.province
      address.consigneeProvinceName = overseaWarehouse.province
      address.consigneeCityCode = overseaWarehouse.cityCode
      address.consigneeCityName = overseaWarehouse.cityName
      address.consigneeAddress1 = overseaWarehouse.address1
      address.consigneeAddress2 = overseaWarehouse.address2
      address.consigneeAddress3 = overseaWarehouse.address3
    },
    // 设置操作分公司
    setOpOffice(val) {
      this.form.opOffice = val
    }
  }

}
</script>

<style lang="scss">
@import "~@/styles/element-variables.scss";

.tab-order-info {
  .el-form-item-w170 {
    width: 170px;
    margin-bottom: 2px !important;

    .el-form-item__content {
      width: 125px;
    }
  }

  .blueStyle {
    color: $--color-primary-light-1;
  }

  .el-form-item-w200 {
    width: 200px;
    margin-bottom: 2px !important;

    .el-form-item__content {
      width: 110px;
    }
  }

  .el-form-item-w240 {
    width: 240px;
    margin-bottom: 2px !important;

    .el-form-item__content {
      width: 160px;
    }
  }

  .el-form-item-w280 {
    width: 280px;
    margin-bottom: 2px !important;

    .el-form-item__content {
      width: 160px;
    }
  }

  .el-form-item-w290 {
    margin-bottom: 2px !important;

    .el-form-item__content {
      width: 160px;
    }
  }

  .el-form-item-w300 {
    width: 300px;
    margin-bottom: 2px !important;

    .el-form-item__content {
      width: 160px;
    }
  }

  .el-form-item-w380 {
    width: 380px;
    margin-bottom: 2px !important;

    .el-form-item__content {
      width: 280px;
    }
  }

  .custom-textarea {
    textarea {
      height: 58px;
    }
  }

  .tag-w {
    width: 100% !important;
  }

  .expanded-div {
    margin-top: 2px;
    position: relative;
    height: 360px;
  }

  .spacing {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .grid-list {
    flex-direction: row;
  }

}

</style>
